/* eslint-disable */
var _excluded = ["ns", "tagName", "className", "style", "children"],
  _excluded2 = ["$lang"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*
 * @license
 * docx-preview <https://github.com/VolodymyrBaydalka/docxjs>
 * Released under Apache License 2.0  <https://github.com/VolodymyrBaydalka/docxjs/blob/master/LICENSE>
 * Copyright Volodymyr Baydalka
 */
import JSZip from 'jszip';
var RelationshipTypes;
(function (RelationshipTypes) {
  RelationshipTypes["OfficeDocument"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument";
  RelationshipTypes["FontTable"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/fontTable";
  RelationshipTypes["Image"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image";
  RelationshipTypes["Numbering"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/numbering";
  RelationshipTypes["Styles"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles";
  RelationshipTypes["StylesWithEffects"] = "http://schemas.microsoft.com/office/2007/relationships/stylesWithEffects";
  RelationshipTypes["Theme"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme";
  RelationshipTypes["Settings"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/settings";
  RelationshipTypes["WebSettings"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/webSettings";
  RelationshipTypes["Hyperlink"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink";
  RelationshipTypes["Footnotes"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footnotes";
  RelationshipTypes["Endnotes"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/endnotes";
  RelationshipTypes["Footer"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footer";
  RelationshipTypes["Header"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/header";
  RelationshipTypes["ExtendedProperties"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties";
  RelationshipTypes["CoreProperties"] = "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties";
  RelationshipTypes["CustomProperties"] = "http://schemas.openxmlformats.org/package/2006/relationships/metadata/custom-properties";
  RelationshipTypes["Comments"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments";
  RelationshipTypes["CommentsExtended"] = "http://schemas.microsoft.com/office/2011/relationships/commentsExtended";
  RelationshipTypes["AltChunk"] = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/aFChunk";
})(RelationshipTypes || (RelationshipTypes = {}));
function parseRelationships(root, xml) {
  return xml.elements(root).map(function (e) {
    return {
      id: xml.attr(e, "Id"),
      type: xml.attr(e, "Type"),
      target: xml.attr(e, "Target"),
      targetMode: xml.attr(e, "TargetMode")
    };
  });
}
function escapeClassName(className) {
  return className === null || className === void 0 ? void 0 : className.replace(/[ .]+/g, '-').replace(/[&]+/g, 'and').toLowerCase();
}
function encloseFontFamily(fontFamily) {
  return /^[^"'].*\s.*[^"']$/.test(fontFamily) ? "'".concat(fontFamily, "'") : fontFamily;
}
function splitPath(path) {
  var si = path.lastIndexOf('/') + 1;
  var folder = si == 0 ? "" : path.substring(0, si);
  var fileName = si == 0 ? path : path.substring(si);
  return [folder, fileName];
}
function resolvePath(path, base) {
  try {
    var prefix = "http://docx/";
    var url = new URL(path, prefix + base).toString();
    return url.substring(prefix.length);
  } catch (_unused) {
    return "".concat(base).concat(path);
  }
}
function keyBy(array, by) {
  return array.reduce(function (a, x) {
    a[by(x)] = x;
    return a;
  }, {});
}
function blobToBase64(blob) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.onloadend = function () {
      return resolve(reader.result);
    };
    reader.onerror = function () {
      return reject();
    };
    reader.readAsDataURL(blob);
  });
}
function isObject(item) {
  return item && _typeof(item) === 'object' && !Array.isArray(item);
}
function isString(item) {
  return typeof item === 'string' || item instanceof String;
}
function mergeDeep(target) {
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }
  if (!sources.length) return target;
  var source = sources.shift();
  if (isObject(target) && isObject(source)) {
    for (var key in source) {
      if (isObject(source[key])) {
        var _target$key;
        var val = (_target$key = target[key]) !== null && _target$key !== void 0 ? _target$key : target[key] = {};
        mergeDeep(val, source[key]);
      } else {
        target[key] = source[key];
      }
    }
  }
  return mergeDeep.apply(void 0, [target].concat(sources));
}
function asArray(val) {
  return Array.isArray(val) ? val : [val];
}
function clamp(val, min, max) {
  return min > val ? min : max < val ? max : val;
}
var ns$1 = {
  wordml: "http://schemas.openxmlformats.org/wordprocessingml/2006/main"
};
var LengthUsage = {
  Dxa: {
    mul: 0.05,
    unit: "pt"
  },
  Emu: {
    mul: 1 / 12700,
    unit: "pt"
  },
  FontSize: {
    mul: 0.5,
    unit: "pt"
  },
  Border: {
    mul: 0.125,
    unit: "pt",
    min: 0.25,
    max: 12
  },
  Point: {
    mul: 1,
    unit: "pt"
  },
  Percent: {
    mul: 0.02,
    unit: "%"
  }
};
function convertLength(val) {
  var usage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : LengthUsage.Dxa;
  if (val == null || /.+(p[xt]|[%])$/.test(val)) {
    return val;
  }
  var num = parseInt(val) * usage.mul;
  if (usage.min && usage.max) num = clamp(num, usage.min, usage.max);
  return "".concat(num.toFixed(2)).concat(usage.unit);
}
function convertBoolean(v) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  switch (v) {
    case "1":
      return true;
    case "0":
      return false;
    case "on":
      return true;
    case "off":
      return false;
    case "true":
      return true;
    case "false":
      return false;
    default:
      return defaultValue;
  }
}
function parseCommonProperty(elem, props, xml) {
  if (elem.namespaceURI != ns$1.wordml) return false;
  switch (elem.localName) {
    case "color":
      props.color = xml.attr(elem, "val");
      break;
    case "sz":
      props.fontSize = xml.lengthAttr(elem, "val", LengthUsage.FontSize);
      break;
    default:
      return false;
  }
  return true;
}
function parseXmlString(xmlString) {
  var trimXmlDeclaration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (trimXmlDeclaration) xmlString = xmlString.replace(/<[?].*[?]>/, "");
  xmlString = removeUTF8BOM(xmlString);
  var result = new DOMParser().parseFromString(xmlString, "application/xml");
  var errorText = hasXmlParserError(result);
  if (errorText) throw new Error(errorText);
  return result;
}
function hasXmlParserError(doc) {
  var _doc$getElementsByTag;
  return (_doc$getElementsByTag = doc.getElementsByTagName("parsererror")[0]) === null || _doc$getElementsByTag === void 0 ? void 0 : _doc$getElementsByTag.textContent;
}
function removeUTF8BOM(data) {
  return data.charCodeAt(0) === 0xFEFF ? data.substring(1) : data;
}
function serializeXmlString(elem) {
  return new XMLSerializer().serializeToString(elem);
}
var XmlParser = /*#__PURE__*/function () {
  function XmlParser() {
    _classCallCheck(this, XmlParser);
  }
  _createClass(XmlParser, [{
    key: "elements",
    value: function elements(elem) {
      var localName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var result = [];
      for (var i = 0, l = elem.childNodes.length; i < l; i++) {
        var c = elem.childNodes.item(i);
        if (c.nodeType == Node.ELEMENT_NODE && (localName == null || c.localName == localName)) result.push(c);
      }
      return result;
    }
  }, {
    key: "element",
    value: function element(elem, localName) {
      for (var i = 0, l = elem.childNodes.length; i < l; i++) {
        var c = elem.childNodes.item(i);
        if (c.nodeType == 1 && c.localName == localName) return c;
      }
      return null;
    }
  }, {
    key: "elementAttr",
    value: function elementAttr(elem, localName, attrLocalName) {
      var el = this.element(elem, localName);
      return el ? this.attr(el, attrLocalName) : undefined;
    }
  }, {
    key: "attrs",
    value: function attrs(elem) {
      return Array.from(elem.attributes);
    }
  }, {
    key: "attr",
    value: function attr(elem, localName) {
      for (var i = 0, l = elem.attributes.length; i < l; i++) {
        var a = elem.attributes.item(i);
        if (a.localName == localName) return a.value;
      }
      return null;
    }
  }, {
    key: "intAttr",
    value: function intAttr(node, attrName) {
      var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var val = this.attr(node, attrName);
      return val ? parseInt(val) : defaultValue;
    }
  }, {
    key: "hexAttr",
    value: function hexAttr(node, attrName) {
      var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var val = this.attr(node, attrName);
      return val ? parseInt(val, 16) : defaultValue;
    }
  }, {
    key: "floatAttr",
    value: function floatAttr(node, attrName) {
      var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var val = this.attr(node, attrName);
      return val ? parseFloat(val) : defaultValue;
    }
  }, {
    key: "boolAttr",
    value: function boolAttr(node, attrName) {
      var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return convertBoolean(this.attr(node, attrName), defaultValue);
    }
  }, {
    key: "lengthAttr",
    value: function lengthAttr(node, attrName) {
      var usage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : LengthUsage.Dxa;
      return convertLength(this.attr(node, attrName), usage);
    }
  }]);
  return XmlParser;
}();
var globalXmlParser = new XmlParser();
var Part = /*#__PURE__*/function () {
  function Part(_package, path) {
    _classCallCheck(this, Part);
    this._package = _package;
    this.path = path;
  }
  _createClass(Part, [{
    key: "load",
    value: function () {
      var _load = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var xmlText, xmlDoc;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._package.loadRelationships(this.path);
              case 2:
                this.rels = _context.sent;
                _context.next = 5;
                return this._package.load(this.path);
              case 5:
                xmlText = _context.sent;
                xmlDoc = this._package.parseXmlDocument(xmlText);
                if (this._package.options.keepOrigin) {
                  this._xmlDocument = xmlDoc;
                }
                this.parseXml(xmlDoc.firstElementChild);
              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function load() {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }, {
    key: "save",
    value: function save() {
      this._package.update(this.path, serializeXmlString(this._xmlDocument));
    }
  }, {
    key: "parseXml",
    value: function parseXml(root) {}
  }]);
  return Part;
}();
var embedFontTypeMap = {
  embedRegular: 'regular',
  embedBold: 'bold',
  embedItalic: 'italic',
  embedBoldItalic: 'boldItalic'
};
function parseFonts(root, xml) {
  return xml.elements(root).map(function (el) {
    return parseFont(el, xml);
  });
}
function parseFont(elem, xml) {
  var result = {
    name: xml.attr(elem, "name"),
    embedFontRefs: []
  };
  var _iterator = _createForOfIteratorHelper(xml.elements(elem)),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var el = _step.value;
      switch (el.localName) {
        case "family":
          result.family = xml.attr(el, "val");
          break;
        case "altName":
          result.altName = xml.attr(el, "val");
          break;
        case "embedRegular":
        case "embedBold":
        case "embedItalic":
        case "embedBoldItalic":
          result.embedFontRefs.push(parseEmbedFontRef(el, xml));
          break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return result;
}
function parseEmbedFontRef(elem, xml) {
  return {
    id: xml.attr(elem, "id"),
    key: xml.attr(elem, "fontKey"),
    type: embedFontTypeMap[elem.localName]
  };
}
var FontTablePart = /*#__PURE__*/function (_Part) {
  _inherits(FontTablePart, _Part);
  var _super = _createSuper(FontTablePart);
  function FontTablePart() {
    _classCallCheck(this, FontTablePart);
    return _super.apply(this, arguments);
  }
  _createClass(FontTablePart, [{
    key: "parseXml",
    value: function parseXml(root) {
      this.fonts = parseFonts(root, this._package.xmlParser);
    }
  }]);
  return FontTablePart;
}(Part);
function parseContentTypes(root, xml) {
  return xml.elements(root).map(function (e) {
    return {
      extension: xml.attr(e, "Extension"),
      partName: xml.attr(e, "PartName"),
      contentType: xml.attr(e, "ContentType")
    };
  });
}
var OpenXmlPackage = /*#__PURE__*/function () {
  function OpenXmlPackage(_zip, options) {
    _classCallCheck(this, OpenXmlPackage);
    this._zip = _zip;
    this.options = options;
    this.xmlParser = new XmlParser();
  }
  _createClass(OpenXmlPackage, [{
    key: "get",
    value: function get(path) {
      var _this$_zip$files$p;
      var p = normalizePath(path);
      return (_this$_zip$files$p = this._zip.files[p]) !== null && _this$_zip$files$p !== void 0 ? _this$_zip$files$p : this._zip.files[p.replace(/\//g, '\\')];
    }
  }, {
    key: "update",
    value: function update(path, content) {
      this._zip.file(path, content);
    }
  }, {
    key: "save",
    value: function save() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "blob";
      return this._zip.generateAsync({
        type: type
      });
    }
  }, {
    key: "load",
    value: function load(path) {
      var _this$get$async, _this$get;
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "string";
      return (_this$get$async = (_this$get = this.get(path)) === null || _this$get === void 0 ? void 0 : _this$get.async(type)) !== null && _this$get$async !== void 0 ? _this$get$async : Promise.resolve(null);
    }
  }, {
    key: "loadRelationships",
    value: function () {
      var _loadRelationships = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var path,
          relsPath,
          _splitPath,
          _splitPath2,
          f,
          fn,
          txt,
          _args2 = arguments;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                path = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : null;
                relsPath = "_rels/.rels";
                if (path != null) {
                  _splitPath = splitPath(path), _splitPath2 = _slicedToArray(_splitPath, 2), f = _splitPath2[0], fn = _splitPath2[1];
                  relsPath = "".concat(f, "_rels/").concat(fn, ".rels");
                }
                _context2.next = 5;
                return this.load(relsPath);
              case 5:
                txt = _context2.sent;
                return _context2.abrupt("return", txt ? parseRelationships(this.parseXmlDocument(txt).firstElementChild, this.xmlParser) : null);
              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function loadRelationships() {
        return _loadRelationships.apply(this, arguments);
      }
      return loadRelationships;
    }()
  }, {
    key: "loadContentTypes",
    value: function () {
      var _loadContentTypes = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var txt;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.load("[Content_Types].xml");
              case 2:
                txt = _context3.sent;
                return _context3.abrupt("return", txt ? parseContentTypes(this.parseXmlDocument(txt).firstElementChild, this.xmlParser) : []);
              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function loadContentTypes() {
        return _loadContentTypes.apply(this, arguments);
      }
      return loadContentTypes;
    }()
  }, {
    key: "parseXmlDocument",
    value: function parseXmlDocument(txt) {
      return parseXmlString(txt, this.options.trimXmlDeclaration);
    }
  }], [{
    key: "load",
    value: function () {
      var _load2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(input, options) {
        var zip;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return JSZip.loadAsync(input);
              case 2:
                zip = _context4.sent;
                return _context4.abrupt("return", new OpenXmlPackage(zip, options));
              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      function load(_x, _x2) {
        return _load2.apply(this, arguments);
      }
      return load;
    }()
  }]);
  return OpenXmlPackage;
}();
function normalizePath(path) {
  return path.startsWith('/') ? path.substr(1) : path;
}
var DocumentPart = /*#__PURE__*/function (_Part2) {
  _inherits(DocumentPart, _Part2);
  var _super2 = _createSuper(DocumentPart);
  function DocumentPart(pkg, path, parser) {
    var _this;
    _classCallCheck(this, DocumentPart);
    _this = _super2.call(this, pkg, path);
    _this._documentParser = parser;
    return _this;
  }
  _createClass(DocumentPart, [{
    key: "parseXml",
    value: function parseXml(root) {
      this.body = this._documentParser.parseDocumentFile(root);
    }
  }]);
  return DocumentPart;
}(Part);
function parseBorder(elem, xml) {
  return {
    type: xml.attr(elem, "val"),
    color: xml.attr(elem, "color"),
    size: xml.lengthAttr(elem, "sz", LengthUsage.Border),
    offset: xml.lengthAttr(elem, "space", LengthUsage.Point),
    frame: xml.boolAttr(elem, 'frame'),
    shadow: xml.boolAttr(elem, 'shadow')
  };
}
function parseBorders(elem, xml) {
  var result = {};
  var _iterator2 = _createForOfIteratorHelper(xml.elements(elem)),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var e = _step2.value;
      switch (e.localName) {
        case "left":
          result.left = parseBorder(e, xml);
          break;
        case "top":
          result.top = parseBorder(e, xml);
          break;
        case "right":
          result.right = parseBorder(e, xml);
          break;
        case "bottom":
          result.bottom = parseBorder(e, xml);
          break;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return result;
}
var SectionType;
(function (SectionType) {
  SectionType["Continuous"] = "continuous";
  SectionType["NextPage"] = "nextPage";
  SectionType["NextColumn"] = "nextColumn";
  SectionType["EvenPage"] = "evenPage";
  SectionType["OddPage"] = "oddPage";
})(SectionType || (SectionType = {}));
function parseSectionProperties(elem) {
  var _section$headerRefs, _section$footerRefs;
  var xml = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalXmlParser;
  var section = {};
  var _iterator3 = _createForOfIteratorHelper(xml.elements(elem)),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var e = _step3.value;
      switch (e.localName) {
        case "pgSz":
          section.pageSize = {
            width: xml.lengthAttr(e, "w"),
            height: xml.lengthAttr(e, "h"),
            orientation: xml.attr(e, "orient")
          };
          break;
        case "type":
          section.type = xml.attr(e, "val");
          break;
        case "pgMar":
          section.pageMargins = {
            left: xml.lengthAttr(e, "left"),
            right: xml.lengthAttr(e, "right"),
            top: xml.lengthAttr(e, "top"),
            bottom: xml.lengthAttr(e, "bottom"),
            header: xml.lengthAttr(e, "header"),
            footer: xml.lengthAttr(e, "footer"),
            gutter: xml.lengthAttr(e, "gutter")
          };
          break;
        case "cols":
          section.columns = parseColumns(e, xml);
          break;
        case "headerReference":
          ((_section$headerRefs = section.headerRefs) !== null && _section$headerRefs !== void 0 ? _section$headerRefs : section.headerRefs = []).push(parseFooterHeaderReference(e, xml));
          break;
        case "footerReference":
          ((_section$footerRefs = section.footerRefs) !== null && _section$footerRefs !== void 0 ? _section$footerRefs : section.footerRefs = []).push(parseFooterHeaderReference(e, xml));
          break;
        case "titlePg":
          section.titlePage = xml.boolAttr(e, "val", true);
          break;
        case "pgBorders":
          section.pageBorders = parseBorders(e, xml);
          break;
        case "pgNumType":
          section.pageNumber = parsePageNumber(e, xml);
          break;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return section;
}
function parseColumns(elem, xml) {
  return {
    numberOfColumns: xml.intAttr(elem, "num"),
    space: xml.lengthAttr(elem, "space"),
    separator: xml.boolAttr(elem, "sep"),
    equalWidth: xml.boolAttr(elem, "equalWidth", true),
    columns: xml.elements(elem, "col").map(function (e) {
      return {
        width: xml.lengthAttr(e, "w"),
        space: xml.lengthAttr(e, "space")
      };
    })
  };
}
function parsePageNumber(elem, xml) {
  return {
    chapSep: xml.attr(elem, "chapSep"),
    chapStyle: xml.attr(elem, "chapStyle"),
    format: xml.attr(elem, "fmt"),
    start: xml.intAttr(elem, "start")
  };
}
function parseFooterHeaderReference(elem, xml) {
  return {
    id: xml.attr(elem, "id"),
    type: xml.attr(elem, "type")
  };
}
function parseLineSpacing(elem, xml) {
  return {
    before: xml.lengthAttr(elem, "before"),
    after: xml.lengthAttr(elem, "after"),
    line: xml.intAttr(elem, "line"),
    lineRule: xml.attr(elem, "lineRule")
  };
}
function parseRunProperties(elem, xml) {
  var result = {};
  var _iterator4 = _createForOfIteratorHelper(xml.elements(elem)),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var el = _step4.value;
      parseRunProperty(el, result, xml);
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return result;
}
function parseRunProperty(elem, props, xml) {
  if (parseCommonProperty(elem, props, xml)) return true;
  return false;
}
function parseParagraphProperties(elem, xml) {
  var result = {};
  var _iterator5 = _createForOfIteratorHelper(xml.elements(elem)),
    _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var el = _step5.value;
      parseParagraphProperty(el, result, xml);
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
  return result;
}
function parseParagraphProperty(elem, props, xml) {
  if (elem.namespaceURI != ns$1.wordml) return false;
  if (parseCommonProperty(elem, props, xml)) return true;
  switch (elem.localName) {
    case "tabs":
      props.tabs = parseTabs(elem, xml);
      break;
    case "sectPr":
      props.sectionProps = parseSectionProperties(elem, xml);
      break;
    case "numPr":
      props.numbering = parseNumbering$1(elem, xml);
      break;
    case "spacing":
      props.lineSpacing = parseLineSpacing(elem, xml);
      return false;
    case "textAlignment":
      props.textAlignment = xml.attr(elem, "val");
      return false;
    case "keepLines":
      props.keepLines = xml.boolAttr(elem, "val", true);
      break;
    case "keepNext":
      props.keepNext = xml.boolAttr(elem, "val", true);
      break;
    case "pageBreakBefore":
      props.pageBreakBefore = xml.boolAttr(elem, "val", true);
      break;
    case "outlineLvl":
      props.outlineLevel = xml.intAttr(elem, "val");
      break;
    case "pStyle":
      props.styleName = xml.attr(elem, "val");
      break;
    case "rPr":
      props.runProps = parseRunProperties(elem, xml);
      break;
    default:
      return false;
  }
  return true;
}
function parseTabs(elem, xml) {
  return xml.elements(elem, "tab").map(function (e) {
    return {
      position: xml.lengthAttr(e, "pos"),
      leader: xml.attr(e, "leader"),
      style: xml.attr(e, "val")
    };
  });
}
function parseNumbering$1(elem, xml) {
  var result = {};
  var _iterator6 = _createForOfIteratorHelper(xml.elements(elem)),
    _step6;
  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var e = _step6.value;
      switch (e.localName) {
        case "numId":
          result.id = xml.attr(e, "val");
          break;
        case "ilvl":
          result.level = xml.intAttr(e, "val");
          break;
      }
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }
  return result;
}
function parseNumberingPart(elem, xml) {
  var result = {
    numberings: [],
    abstractNumberings: [],
    bulletPictures: []
  };
  var _iterator7 = _createForOfIteratorHelper(xml.elements(elem)),
    _step7;
  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var e = _step7.value;
      switch (e.localName) {
        case "num":
          result.numberings.push(parseNumbering(e, xml));
          break;
        case "abstractNum":
          result.abstractNumberings.push(parseAbstractNumbering(e, xml));
          break;
        case "numPicBullet":
          result.bulletPictures.push(parseNumberingBulletPicture(e, xml));
          break;
      }
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }
  return result;
}
function parseNumbering(elem, xml) {
  var result = {
    id: xml.attr(elem, 'numId'),
    overrides: []
  };
  var _iterator8 = _createForOfIteratorHelper(xml.elements(elem)),
    _step8;
  try {
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      var e = _step8.value;
      switch (e.localName) {
        case "abstractNumId":
          result.abstractId = xml.attr(e, "val");
          break;
        case "lvlOverride":
          result.overrides.push(parseNumberingLevelOverrride(e, xml));
          break;
      }
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }
  return result;
}
function parseAbstractNumbering(elem, xml) {
  var result = {
    id: xml.attr(elem, 'abstractNumId'),
    levels: []
  };
  var _iterator9 = _createForOfIteratorHelper(xml.elements(elem)),
    _step9;
  try {
    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
      var e = _step9.value;
      switch (e.localName) {
        case "name":
          result.name = xml.attr(e, "val");
          break;
        case "multiLevelType":
          result.multiLevelType = xml.attr(e, "val");
          break;
        case "numStyleLink":
          result.numberingStyleLink = xml.attr(e, "val");
          break;
        case "styleLink":
          result.styleLink = xml.attr(e, "val");
          break;
        case "lvl":
          result.levels.push(parseNumberingLevel(e, xml));
          break;
      }
    }
  } catch (err) {
    _iterator9.e(err);
  } finally {
    _iterator9.f();
  }
  return result;
}
function parseNumberingLevel(elem, xml) {
  var result = {
    level: xml.intAttr(elem, 'ilvl')
  };
  var _iterator0 = _createForOfIteratorHelper(xml.elements(elem)),
    _step0;
  try {
    for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
      var e = _step0.value;
      switch (e.localName) {
        case "start":
          result.start = xml.attr(e, "val");
          break;
        case "lvlRestart":
          result.restart = xml.intAttr(e, "val");
          break;
        case "numFmt":
          result.format = xml.attr(e, "val");
          break;
        case "lvlText":
          result.text = xml.attr(e, "val");
          break;
        case "lvlJc":
          result.justification = xml.attr(e, "val");
          break;
        case "lvlPicBulletId":
          result.bulletPictureId = xml.attr(e, "val");
          break;
        case "pStyle":
          result.paragraphStyle = xml.attr(e, "val");
          break;
        case "pPr":
          result.paragraphProps = parseParagraphProperties(e, xml);
          break;
        case "rPr":
          result.runProps = parseRunProperties(e, xml);
          break;
      }
    }
  } catch (err) {
    _iterator0.e(err);
  } finally {
    _iterator0.f();
  }
  return result;
}
function parseNumberingLevelOverrride(elem, xml) {
  var result = {
    level: xml.intAttr(elem, 'ilvl')
  };
  var _iterator1 = _createForOfIteratorHelper(xml.elements(elem)),
    _step1;
  try {
    for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
      var e = _step1.value;
      switch (e.localName) {
        case "startOverride":
          result.start = xml.intAttr(e, "val");
          break;
        case "lvl":
          result.numberingLevel = parseNumberingLevel(e, xml);
          break;
      }
    }
  } catch (err) {
    _iterator1.e(err);
  } finally {
    _iterator1.f();
  }
  return result;
}
function parseNumberingBulletPicture(elem, xml) {
  var pict = xml.element(elem, "pict");
  var shape = pict && xml.element(pict, "shape");
  var imagedata = shape && xml.element(shape, "imagedata");
  return imagedata ? {
    id: xml.attr(elem, "numPicBulletId"),
    referenceId: xml.attr(imagedata, "id"),
    style: xml.attr(shape, "style")
  } : null;
}
var NumberingPart = /*#__PURE__*/function (_Part3) {
  _inherits(NumberingPart, _Part3);
  var _super3 = _createSuper(NumberingPart);
  function NumberingPart(pkg, path, parser) {
    var _this2;
    _classCallCheck(this, NumberingPart);
    _this2 = _super3.call(this, pkg, path);
    _this2._documentParser = parser;
    return _this2;
  }
  _createClass(NumberingPart, [{
    key: "parseXml",
    value: function parseXml(root) {
      Object.assign(this, parseNumberingPart(root, this._package.xmlParser));
      this.domNumberings = this._documentParser.parseNumberingFile(root);
    }
  }]);
  return NumberingPart;
}(Part);
var StylesPart = /*#__PURE__*/function (_Part4) {
  _inherits(StylesPart, _Part4);
  var _super4 = _createSuper(StylesPart);
  function StylesPart(pkg, path, parser) {
    var _this3;
    _classCallCheck(this, StylesPart);
    _this3 = _super4.call(this, pkg, path);
    _this3._documentParser = parser;
    return _this3;
  }
  _createClass(StylesPart, [{
    key: "parseXml",
    value: function parseXml(root) {
      this.styles = this._documentParser.parseStylesFile(root);
    }
  }]);
  return StylesPart;
}(Part);
var DomType;
(function (DomType) {
  DomType["Document"] = "document";
  DomType["Paragraph"] = "paragraph";
  DomType["Run"] = "run";
  DomType["Break"] = "break";
  DomType["NoBreakHyphen"] = "noBreakHyphen";
  DomType["Table"] = "table";
  DomType["Row"] = "row";
  DomType["Cell"] = "cell";
  DomType["Hyperlink"] = "hyperlink";
  DomType["SmartTag"] = "smartTag";
  DomType["Drawing"] = "drawing";
  DomType["Image"] = "image";
  DomType["Text"] = "text";
  DomType["Tab"] = "tab";
  DomType["Symbol"] = "symbol";
  DomType["BookmarkStart"] = "bookmarkStart";
  DomType["BookmarkEnd"] = "bookmarkEnd";
  DomType["Footer"] = "footer";
  DomType["Header"] = "header";
  DomType["FootnoteReference"] = "footnoteReference";
  DomType["EndnoteReference"] = "endnoteReference";
  DomType["Footnote"] = "footnote";
  DomType["Endnote"] = "endnote";
  DomType["SimpleField"] = "simpleField";
  DomType["ComplexField"] = "complexField";
  DomType["Instruction"] = "instruction";
  DomType["VmlPicture"] = "vmlPicture";
  DomType["MmlMath"] = "mmlMath";
  DomType["MmlMathParagraph"] = "mmlMathParagraph";
  DomType["MmlFraction"] = "mmlFraction";
  DomType["MmlFunction"] = "mmlFunction";
  DomType["MmlFunctionName"] = "mmlFunctionName";
  DomType["MmlNumerator"] = "mmlNumerator";
  DomType["MmlDenominator"] = "mmlDenominator";
  DomType["MmlRadical"] = "mmlRadical";
  DomType["MmlBase"] = "mmlBase";
  DomType["MmlDegree"] = "mmlDegree";
  DomType["MmlSuperscript"] = "mmlSuperscript";
  DomType["MmlSubscript"] = "mmlSubscript";
  DomType["MmlPreSubSuper"] = "mmlPreSubSuper";
  DomType["MmlSubArgument"] = "mmlSubArgument";
  DomType["MmlSuperArgument"] = "mmlSuperArgument";
  DomType["MmlNary"] = "mmlNary";
  DomType["MmlDelimiter"] = "mmlDelimiter";
  DomType["MmlRun"] = "mmlRun";
  DomType["MmlEquationArray"] = "mmlEquationArray";
  DomType["MmlLimit"] = "mmlLimit";
  DomType["MmlLimitLower"] = "mmlLimitLower";
  DomType["MmlMatrix"] = "mmlMatrix";
  DomType["MmlMatrixRow"] = "mmlMatrixRow";
  DomType["MmlBox"] = "mmlBox";
  DomType["MmlBar"] = "mmlBar";
  DomType["MmlGroupChar"] = "mmlGroupChar";
  DomType["VmlElement"] = "vmlElement";
  DomType["Inserted"] = "inserted";
  DomType["Deleted"] = "deleted";
  DomType["DeletedText"] = "deletedText";
  DomType["Comment"] = "comment";
  DomType["CommentReference"] = "commentReference";
  DomType["CommentRangeStart"] = "commentRangeStart";
  DomType["CommentRangeEnd"] = "commentRangeEnd";
  DomType["AltChunk"] = "altChunk";
})(DomType || (DomType = {}));
var OpenXmlElementBase = function OpenXmlElementBase() {
  _classCallCheck(this, OpenXmlElementBase);
  this.children = [];
  this.cssStyle = {};
};
var WmlHeader = /*#__PURE__*/function (_OpenXmlElementBase) {
  _inherits(WmlHeader, _OpenXmlElementBase);
  var _super5 = _createSuper(WmlHeader);
  function WmlHeader() {
    var _this4;
    _classCallCheck(this, WmlHeader);
    _this4 = _super5.apply(this, arguments);
    _this4.type = DomType.Header;
    return _this4;
  }
  return WmlHeader;
}(OpenXmlElementBase);
var WmlFooter = /*#__PURE__*/function (_OpenXmlElementBase2) {
  _inherits(WmlFooter, _OpenXmlElementBase2);
  var _super6 = _createSuper(WmlFooter);
  function WmlFooter() {
    var _this5;
    _classCallCheck(this, WmlFooter);
    _this5 = _super6.apply(this, arguments);
    _this5.type = DomType.Footer;
    return _this5;
  }
  return WmlFooter;
}(OpenXmlElementBase);
var BaseHeaderFooterPart = /*#__PURE__*/function (_Part5) {
  _inherits(BaseHeaderFooterPart, _Part5);
  var _super7 = _createSuper(BaseHeaderFooterPart);
  function BaseHeaderFooterPart(pkg, path, parser) {
    var _this6;
    _classCallCheck(this, BaseHeaderFooterPart);
    _this6 = _super7.call(this, pkg, path);
    _this6._documentParser = parser;
    return _this6;
  }
  _createClass(BaseHeaderFooterPart, [{
    key: "parseXml",
    value: function parseXml(root) {
      this.rootElement = this.createRootElement();
      this.rootElement.children = this._documentParser.parseBodyElements(root);
    }
  }]);
  return BaseHeaderFooterPart;
}(Part);
var HeaderPart = /*#__PURE__*/function (_BaseHeaderFooterPart) {
  _inherits(HeaderPart, _BaseHeaderFooterPart);
  var _super8 = _createSuper(HeaderPart);
  function HeaderPart() {
    _classCallCheck(this, HeaderPart);
    return _super8.apply(this, arguments);
  }
  _createClass(HeaderPart, [{
    key: "createRootElement",
    value: function createRootElement() {
      return new WmlHeader();
    }
  }]);
  return HeaderPart;
}(BaseHeaderFooterPart);
var FooterPart = /*#__PURE__*/function (_BaseHeaderFooterPart2) {
  _inherits(FooterPart, _BaseHeaderFooterPart2);
  var _super9 = _createSuper(FooterPart);
  function FooterPart() {
    _classCallCheck(this, FooterPart);
    return _super9.apply(this, arguments);
  }
  _createClass(FooterPart, [{
    key: "createRootElement",
    value: function createRootElement() {
      return new WmlFooter();
    }
  }]);
  return FooterPart;
}(BaseHeaderFooterPart);
function parseExtendedProps(root, xmlParser) {
  var result = {};
  var _iterator10 = _createForOfIteratorHelper(xmlParser.elements(root)),
    _step10;
  try {
    for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
      var el = _step10.value;
      switch (el.localName) {
        case "Template":
          result.template = el.textContent;
          break;
        case "Pages":
          result.pages = safeParseToInt(el.textContent);
          break;
        case "Words":
          result.words = safeParseToInt(el.textContent);
          break;
        case "Characters":
          result.characters = safeParseToInt(el.textContent);
          break;
        case "Application":
          result.application = el.textContent;
          break;
        case "Lines":
          result.lines = safeParseToInt(el.textContent);
          break;
        case "Paragraphs":
          result.paragraphs = safeParseToInt(el.textContent);
          break;
        case "Company":
          result.company = el.textContent;
          break;
        case "AppVersion":
          result.appVersion = el.textContent;
          break;
      }
    }
  } catch (err) {
    _iterator10.e(err);
  } finally {
    _iterator10.f();
  }
  return result;
}
function safeParseToInt(value) {
  if (typeof value === 'undefined') return;
  return parseInt(value);
}
var ExtendedPropsPart = /*#__PURE__*/function (_Part6) {
  _inherits(ExtendedPropsPart, _Part6);
  var _super0 = _createSuper(ExtendedPropsPart);
  function ExtendedPropsPart() {
    _classCallCheck(this, ExtendedPropsPart);
    return _super0.apply(this, arguments);
  }
  _createClass(ExtendedPropsPart, [{
    key: "parseXml",
    value: function parseXml(root) {
      this.props = parseExtendedProps(root, this._package.xmlParser);
    }
  }]);
  return ExtendedPropsPart;
}(Part);
function parseCoreProps(root, xmlParser) {
  var result = {};
  var _iterator11 = _createForOfIteratorHelper(xmlParser.elements(root)),
    _step11;
  try {
    for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
      var el = _step11.value;
      switch (el.localName) {
        case "title":
          result.title = el.textContent;
          break;
        case "description":
          result.description = el.textContent;
          break;
        case "subject":
          result.subject = el.textContent;
          break;
        case "creator":
          result.creator = el.textContent;
          break;
        case "keywords":
          result.keywords = el.textContent;
          break;
        case "language":
          result.language = el.textContent;
          break;
        case "lastModifiedBy":
          result.lastModifiedBy = el.textContent;
          break;
        case "revision":
          el.textContent && (result.revision = parseInt(el.textContent));
          break;
      }
    }
  } catch (err) {
    _iterator11.e(err);
  } finally {
    _iterator11.f();
  }
  return result;
}
var CorePropsPart = /*#__PURE__*/function (_Part7) {
  _inherits(CorePropsPart, _Part7);
  var _super1 = _createSuper(CorePropsPart);
  function CorePropsPart() {
    _classCallCheck(this, CorePropsPart);
    return _super1.apply(this, arguments);
  }
  _createClass(CorePropsPart, [{
    key: "parseXml",
    value: function parseXml(root) {
      this.props = parseCoreProps(root, this._package.xmlParser);
    }
  }]);
  return CorePropsPart;
}(Part);
var DmlTheme = function DmlTheme() {
  _classCallCheck(this, DmlTheme);
};
function parseTheme(elem, xml) {
  var result = new DmlTheme();
  var themeElements = xml.element(elem, "themeElements");
  var _iterator12 = _createForOfIteratorHelper(xml.elements(themeElements)),
    _step12;
  try {
    for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
      var el = _step12.value;
      switch (el.localName) {
        case "clrScheme":
          result.colorScheme = parseColorScheme(el, xml);
          break;
        case "fontScheme":
          result.fontScheme = parseFontScheme(el, xml);
          break;
      }
    }
  } catch (err) {
    _iterator12.e(err);
  } finally {
    _iterator12.f();
  }
  return result;
}
function parseColorScheme(elem, xml) {
  var result = {
    name: xml.attr(elem, "name"),
    colors: {}
  };
  var _iterator13 = _createForOfIteratorHelper(xml.elements(elem)),
    _step13;
  try {
    for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
      var el = _step13.value;
      var srgbClr = xml.element(el, "srgbClr");
      var sysClr = xml.element(el, "sysClr");
      if (srgbClr) {
        result.colors[el.localName] = xml.attr(srgbClr, "val");
      } else if (sysClr) {
        result.colors[el.localName] = xml.attr(sysClr, "lastClr");
      }
    }
  } catch (err) {
    _iterator13.e(err);
  } finally {
    _iterator13.f();
  }
  return result;
}
function parseFontScheme(elem, xml) {
  var result = {
    name: xml.attr(elem, "name")
  };
  var _iterator14 = _createForOfIteratorHelper(xml.elements(elem)),
    _step14;
  try {
    for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
      var el = _step14.value;
      switch (el.localName) {
        case "majorFont":
          result.majorFont = parseFontInfo(el, xml);
          break;
        case "minorFont":
          result.minorFont = parseFontInfo(el, xml);
          break;
      }
    }
  } catch (err) {
    _iterator14.e(err);
  } finally {
    _iterator14.f();
  }
  return result;
}
function parseFontInfo(elem, xml) {
  return {
    latinTypeface: xml.elementAttr(elem, "latin", "typeface"),
    eaTypeface: xml.elementAttr(elem, "ea", "typeface"),
    csTypeface: xml.elementAttr(elem, "cs", "typeface")
  };
}
var ThemePart = /*#__PURE__*/function (_Part8) {
  _inherits(ThemePart, _Part8);
  var _super10 = _createSuper(ThemePart);
  function ThemePart(pkg, path) {
    _classCallCheck(this, ThemePart);
    return _super10.call(this, pkg, path);
  }
  _createClass(ThemePart, [{
    key: "parseXml",
    value: function parseXml(root) {
      this.theme = parseTheme(root, this._package.xmlParser);
    }
  }]);
  return ThemePart;
}(Part);
var WmlBaseNote = function WmlBaseNote() {
  _classCallCheck(this, WmlBaseNote);
};
var WmlFootnote = /*#__PURE__*/function (_WmlBaseNote) {
  _inherits(WmlFootnote, _WmlBaseNote);
  var _super11 = _createSuper(WmlFootnote);
  function WmlFootnote() {
    var _this7;
    _classCallCheck(this, WmlFootnote);
    _this7 = _super11.apply(this, arguments);
    _this7.type = DomType.Footnote;
    return _this7;
  }
  return WmlFootnote;
}(WmlBaseNote);
var WmlEndnote = /*#__PURE__*/function (_WmlBaseNote2) {
  _inherits(WmlEndnote, _WmlBaseNote2);
  var _super12 = _createSuper(WmlEndnote);
  function WmlEndnote() {
    var _this8;
    _classCallCheck(this, WmlEndnote);
    _this8 = _super12.apply(this, arguments);
    _this8.type = DomType.Endnote;
    return _this8;
  }
  return WmlEndnote;
}(WmlBaseNote);
var BaseNotePart = /*#__PURE__*/function (_Part9) {
  _inherits(BaseNotePart, _Part9);
  var _super13 = _createSuper(BaseNotePart);
  function BaseNotePart(pkg, path, parser) {
    var _this9;
    _classCallCheck(this, BaseNotePart);
    _this9 = _super13.call(this, pkg, path);
    _this9._documentParser = parser;
    return _this9;
  }
  return BaseNotePart;
}(Part);
var FootnotesPart = /*#__PURE__*/function (_BaseNotePart) {
  _inherits(FootnotesPart, _BaseNotePart);
  var _super14 = _createSuper(FootnotesPart);
  function FootnotesPart(pkg, path, parser) {
    _classCallCheck(this, FootnotesPart);
    return _super14.call(this, pkg, path, parser);
  }
  _createClass(FootnotesPart, [{
    key: "parseXml",
    value: function parseXml(root) {
      this.notes = this._documentParser.parseNotes(root, "footnote", WmlFootnote);
    }
  }]);
  return FootnotesPart;
}(BaseNotePart);
var EndnotesPart = /*#__PURE__*/function (_BaseNotePart2) {
  _inherits(EndnotesPart, _BaseNotePart2);
  var _super15 = _createSuper(EndnotesPart);
  function EndnotesPart(pkg, path, parser) {
    _classCallCheck(this, EndnotesPart);
    return _super15.call(this, pkg, path, parser);
  }
  _createClass(EndnotesPart, [{
    key: "parseXml",
    value: function parseXml(root) {
      this.notes = this._documentParser.parseNotes(root, "endnote", WmlEndnote);
    }
  }]);
  return EndnotesPart;
}(BaseNotePart);
function parseSettings(elem, xml) {
  var result = {};
  var _iterator15 = _createForOfIteratorHelper(xml.elements(elem)),
    _step15;
  try {
    for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
      var el = _step15.value;
      switch (el.localName) {
        case "defaultTabStop":
          result.defaultTabStop = xml.lengthAttr(el, "val");
          break;
        case "footnotePr":
          result.footnoteProps = parseNoteProperties(el, xml);
          break;
        case "endnotePr":
          result.endnoteProps = parseNoteProperties(el, xml);
          break;
        case "autoHyphenation":
          result.autoHyphenation = xml.boolAttr(el, "val");
          break;
        case "evenAndOddHeaders":
          result.evenAndOddHeaders = xml.boolAttr(el, "val", true);
          break;
      }
    }
  } catch (err) {
    _iterator15.e(err);
  } finally {
    _iterator15.f();
  }
  return result;
}
function parseNoteProperties(elem, xml) {
  var result = {
    defaultNoteIds: []
  };
  var _iterator16 = _createForOfIteratorHelper(xml.elements(elem)),
    _step16;
  try {
    for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
      var el = _step16.value;
      switch (el.localName) {
        case "numFmt":
          result.nummeringFormat = xml.attr(el, "val");
          break;
        case "footnote":
        case "endnote":
          result.defaultNoteIds.push(xml.attr(el, "id"));
          break;
      }
    }
  } catch (err) {
    _iterator16.e(err);
  } finally {
    _iterator16.f();
  }
  return result;
}
var SettingsPart = /*#__PURE__*/function (_Part0) {
  _inherits(SettingsPart, _Part0);
  var _super16 = _createSuper(SettingsPart);
  function SettingsPart(pkg, path) {
    _classCallCheck(this, SettingsPart);
    return _super16.call(this, pkg, path);
  }
  _createClass(SettingsPart, [{
    key: "parseXml",
    value: function parseXml(root) {
      this.settings = parseSettings(root, this._package.xmlParser);
    }
  }]);
  return SettingsPart;
}(Part);
function parseCustomProps(root, xml) {
  return xml.elements(root, "property").map(function (e) {
    var firstChild = e.firstChild;
    return {
      formatId: xml.attr(e, "fmtid"),
      name: xml.attr(e, "name"),
      type: firstChild.nodeName,
      value: firstChild.textContent
    };
  });
}
var CustomPropsPart = /*#__PURE__*/function (_Part1) {
  _inherits(CustomPropsPart, _Part1);
  var _super17 = _createSuper(CustomPropsPart);
  function CustomPropsPart() {
    _classCallCheck(this, CustomPropsPart);
    return _super17.apply(this, arguments);
  }
  _createClass(CustomPropsPart, [{
    key: "parseXml",
    value: function parseXml(root) {
      this.props = parseCustomProps(root, this._package.xmlParser);
    }
  }]);
  return CustomPropsPart;
}(Part);
var CommentsPart = /*#__PURE__*/function (_Part10) {
  _inherits(CommentsPart, _Part10);
  var _super18 = _createSuper(CommentsPart);
  function CommentsPart(pkg, path, parser) {
    var _this0;
    _classCallCheck(this, CommentsPart);
    _this0 = _super18.call(this, pkg, path);
    _this0._documentParser = parser;
    return _this0;
  }
  _createClass(CommentsPart, [{
    key: "parseXml",
    value: function parseXml(root) {
      this.comments = this._documentParser.parseComments(root);
      this.commentMap = keyBy(this.comments, function (x) {
        return x.id;
      });
    }
  }]);
  return CommentsPart;
}(Part);
var CommentsExtendedPart = /*#__PURE__*/function (_Part11) {
  _inherits(CommentsExtendedPart, _Part11);
  var _super19 = _createSuper(CommentsExtendedPart);
  function CommentsExtendedPart(pkg, path) {
    var _this1;
    _classCallCheck(this, CommentsExtendedPart);
    _this1 = _super19.call(this, pkg, path);
    _this1.comments = [];
    return _this1;
  }
  _createClass(CommentsExtendedPart, [{
    key: "parseXml",
    value: function parseXml(root) {
      var xml = this._package.xmlParser;
      var _iterator17 = _createForOfIteratorHelper(xml.elements(root, "commentEx")),
        _step17;
      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var el = _step17.value;
          this.comments.push({
            paraId: xml.attr(el, 'paraId'),
            paraIdParent: xml.attr(el, 'paraIdParent'),
            done: xml.boolAttr(el, 'done')
          });
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }
      this.commentMap = keyBy(this.comments, function (x) {
        return x.paraId;
      });
    }
  }]);
  return CommentsExtendedPart;
}(Part);
var topLevelRels = [{
  type: RelationshipTypes.OfficeDocument,
  target: "word/document.xml"
}, {
  type: RelationshipTypes.ExtendedProperties,
  target: "docProps/app.xml"
}, {
  type: RelationshipTypes.CoreProperties,
  target: "docProps/core.xml"
}, {
  type: RelationshipTypes.CustomProperties,
  target: "docProps/custom.xml"
}];
var WordDocument = /*#__PURE__*/function () {
  function WordDocument() {
    _classCallCheck(this, WordDocument);
    this.parts = [];
    this.partsMap = {};
    this.contentTypes = [];
  }
  _createClass(WordDocument, [{
    key: "save",
    value: function save() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "blob";
      return this._package.save(type);
    }
  }, {
    key: "loadRelationshipPart",
    value: function () {
      var _loadRelationshipPart = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(path, type) {
        var _part$rels,
          _this10 = this;
        var part, _splitPath3, _splitPath4, folder;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!this.partsMap[path]) {
                  _context5.next = 2;
                  break;
                }
                return _context5.abrupt("return", this.partsMap[path]);
              case 2:
                if (this._package.get(path)) {
                  _context5.next = 4;
                  break;
                }
                return _context5.abrupt("return", null);
              case 4:
                part = null;
                _context5.t0 = type;
                _context5.next = _context5.t0 === RelationshipTypes.OfficeDocument ? 8 : _context5.t0 === RelationshipTypes.FontTable ? 10 : _context5.t0 === RelationshipTypes.Numbering ? 12 : _context5.t0 === RelationshipTypes.Styles ? 14 : _context5.t0 === RelationshipTypes.Theme ? 16 : _context5.t0 === RelationshipTypes.Footnotes ? 18 : _context5.t0 === RelationshipTypes.Endnotes ? 20 : _context5.t0 === RelationshipTypes.Footer ? 22 : _context5.t0 === RelationshipTypes.Header ? 24 : _context5.t0 === RelationshipTypes.CoreProperties ? 26 : _context5.t0 === RelationshipTypes.ExtendedProperties ? 28 : _context5.t0 === RelationshipTypes.CustomProperties ? 30 : _context5.t0 === RelationshipTypes.Settings ? 32 : _context5.t0 === RelationshipTypes.Comments ? 34 : _context5.t0 === RelationshipTypes.CommentsExtended ? 36 : 38;
                break;
              case 8:
                this.documentPart = part = new DocumentPart(this._package, path, this._parser);
                return _context5.abrupt("break", 38);
              case 10:
                this.fontTablePart = part = new FontTablePart(this._package, path);
                return _context5.abrupt("break", 38);
              case 12:
                this.numberingPart = part = new NumberingPart(this._package, path, this._parser);
                return _context5.abrupt("break", 38);
              case 14:
                this.stylesPart = part = new StylesPart(this._package, path, this._parser);
                return _context5.abrupt("break", 38);
              case 16:
                this.themePart = part = new ThemePart(this._package, path);
                return _context5.abrupt("break", 38);
              case 18:
                this.footnotesPart = part = new FootnotesPart(this._package, path, this._parser);
                return _context5.abrupt("break", 38);
              case 20:
                this.endnotesPart = part = new EndnotesPart(this._package, path, this._parser);
                return _context5.abrupt("break", 38);
              case 22:
                part = new FooterPart(this._package, path, this._parser);
                return _context5.abrupt("break", 38);
              case 24:
                part = new HeaderPart(this._package, path, this._parser);
                return _context5.abrupt("break", 38);
              case 26:
                this.corePropsPart = part = new CorePropsPart(this._package, path);
                return _context5.abrupt("break", 38);
              case 28:
                this.extendedPropsPart = part = new ExtendedPropsPart(this._package, path);
                return _context5.abrupt("break", 38);
              case 30:
                part = new CustomPropsPart(this._package, path);
                return _context5.abrupt("break", 38);
              case 32:
                this.settingsPart = part = new SettingsPart(this._package, path);
                return _context5.abrupt("break", 38);
              case 34:
                this.commentsPart = part = new CommentsPart(this._package, path, this._parser);
                return _context5.abrupt("break", 38);
              case 36:
                this.commentsExtendedPart = part = new CommentsExtendedPart(this._package, path);
                return _context5.abrupt("break", 38);
              case 38:
                if (!(part == null)) {
                  _context5.next = 40;
                  break;
                }
                return _context5.abrupt("return", Promise.resolve(null));
              case 40:
                this.partsMap[path] = part;
                this.parts.push(part);
                _context5.next = 44;
                return part.load();
              case 44:
                if (!(((_part$rels = part.rels) === null || _part$rels === void 0 ? void 0 : _part$rels.length) > 0)) {
                  _context5.next = 48;
                  break;
                }
                _splitPath3 = splitPath(part.path), _splitPath4 = _slicedToArray(_splitPath3, 1), folder = _splitPath4[0];
                _context5.next = 48;
                return Promise.all(part.rels.map(function (rel) {
                  return _this10.loadRelationshipPart(resolvePath(rel.target, folder), rel.type);
                }));
              case 48:
                return _context5.abrupt("return", part);
              case 49:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
      function loadRelationshipPart(_x3, _x4) {
        return _loadRelationshipPart.apply(this, arguments);
      }
      return loadRelationshipPart;
    }()
  }, {
    key: "loadDocumentImage",
    value: function () {
      var _loadDocumentImage = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(id, part) {
        var path;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                path = this.getPathById(part !== null && part !== void 0 ? part : this.documentPart, id);
                if (!path) {
                  _context6.next = 10;
                  break;
                }
                _context6.t1 = this;
                _context6.next = 5;
                return this._package.load(path, "blob");
              case 5:
                _context6.t2 = _context6.sent;
                _context6.t3 = path;
                _context6.t0 = _context6.t1.blobToURL.call(_context6.t1, _context6.t2, _context6.t3);
                _context6.next = 11;
                break;
              case 10:
                _context6.t0 = null;
              case 11:
                return _context6.abrupt("return", _context6.t0);
              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
      function loadDocumentImage(_x5, _x6) {
        return _loadDocumentImage.apply(this, arguments);
      }
      return loadDocumentImage;
    }()
  }, {
    key: "loadNumberingImage",
    value: function () {
      var _loadNumberingImage = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(id) {
        var path;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                path = this.getPathById(this.numberingPart, id);
                if (!path) {
                  _context7.next = 10;
                  break;
                }
                _context7.t1 = this;
                _context7.next = 5;
                return this._package.load(path, "blob");
              case 5:
                _context7.t2 = _context7.sent;
                _context7.t3 = path;
                _context7.t0 = _context7.t1.blobToURL.call(_context7.t1, _context7.t2, _context7.t3);
                _context7.next = 11;
                break;
              case 10:
                _context7.t0 = null;
              case 11:
                return _context7.abrupt("return", _context7.t0);
              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
      function loadNumberingImage(_x7) {
        return _loadNumberingImage.apply(this, arguments);
      }
      return loadNumberingImage;
    }()
  }, {
    key: "loadFont",
    value: function () {
      var _loadFont = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8(id, key) {
        var path, x;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                path = this.getPathById(this.fontTablePart, id);
                if (path) {
                  _context8.next = 3;
                  break;
                }
                return _context8.abrupt("return", null);
              case 3:
                _context8.next = 5;
                return this._package.load(path, "uint8array");
              case 5:
                x = _context8.sent;
                return _context8.abrupt("return", x ? this.blobToURL(new Blob([deobfuscate(x, key)]), path) : x);
              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
      function loadFont(_x8, _x9) {
        return _loadFont.apply(this, arguments);
      }
      return loadFont;
    }()
  }, {
    key: "loadAltChunk",
    value: function () {
      var _loadAltChunk = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee9(id, part) {
        var path;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                path = this.getPathById(part !== null && part !== void 0 ? part : this.documentPart, id);
                return _context9.abrupt("return", path ? this._package.load(path, "string") : Promise.resolve(null));
              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
      function loadAltChunk(_x0, _x1) {
        return _loadAltChunk.apply(this, arguments);
      }
      return loadAltChunk;
    }()
  }, {
    key: "blobToURL",
    value: function blobToURL(blob, path) {
      if (!blob) return null;
      if (path) {
        var ct = this.contentTypes.find(function (x) {
          return x.partName === path || x.extension && path.endsWith(".".concat(x.extension));
        });
        blob = ct ? new Blob([blob], {
          type: ct.contentType
        }) : blob;
      }
      if (this._options.useBase64URL) {
        return blobToBase64(blob);
      }
      return URL.createObjectURL(blob);
    }
  }, {
    key: "findPartByRelId",
    value: function findPartByRelId(id) {
      var _basePart$rels;
      var basePart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var rel = ((_basePart$rels = basePart.rels) !== null && _basePart$rels !== void 0 ? _basePart$rels : this.rels).find(function (r) {
        return r.id == id;
      });
      var folder = basePart ? splitPath(basePart.path)[0] : '';
      return rel ? this.partsMap[resolvePath(rel.target, folder)] : null;
    }
  }, {
    key: "getPathById",
    value: function getPathById(part, id) {
      var rel = part.rels.find(function (x) {
        return x.id == id;
      });
      var _splitPath5 = splitPath(part.path),
        _splitPath6 = _slicedToArray(_splitPath5, 1),
        folder = _splitPath6[0];
      return rel ? resolvePath(rel.target, folder) : null;
    }
  }], [{
    key: "load",
    value: function () {
      var _load3 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee0(blob, parser, options) {
        var d;
        return regeneratorRuntime.wrap(function _callee0$(_context0) {
          while (1) {
            switch (_context0.prev = _context0.next) {
              case 0:
                d = new WordDocument();
                d._options = options;
                d._parser = parser;
                _context0.next = 5;
                return OpenXmlPackage.load(blob, options);
              case 5:
                d._package = _context0.sent;
                _context0.next = 8;
                return d._package.loadRelationships();
              case 8:
                d.rels = _context0.sent;
                _context0.next = 11;
                return d._package.loadContentTypes();
              case 11:
                d.contentTypes = _context0.sent;
                _context0.next = 14;
                return Promise.all(topLevelRels.map(function (rel) {
                  var _d$rels$find;
                  var r = (_d$rels$find = d.rels.find(function (x) {
                    return x.type === rel.type;
                  })) !== null && _d$rels$find !== void 0 ? _d$rels$find : rel;
                  return d.loadRelationshipPart(r.target, r.type);
                }));
              case 14:
                return _context0.abrupt("return", d);
              case 15:
              case "end":
                return _context0.stop();
            }
          }
        }, _callee0);
      }));
      function load(_x10, _x11, _x12) {
        return _load3.apply(this, arguments);
      }
      return load;
    }()
  }]);
  return WordDocument;
}();
function deobfuscate(data, guidKey) {
  var len = 16;
  var trimmed = guidKey.replace(/{|}|-/g, "");
  var numbers = new Array(len);
  for (var i = 0; i < len; i++) {
    numbers[len - i - 1] = parseInt(trimmed.substring(i * 2, i * 2 + 2), 16);
  }
  for (var _i = 0; _i < 32; _i++) {
    data[_i] = data[_i] ^ numbers[_i % len];
  }
  return data;
}
function parseBookmarkStart(elem, xml) {
  return {
    type: DomType.BookmarkStart,
    id: xml.attr(elem, "id"),
    name: xml.attr(elem, "name"),
    colFirst: xml.intAttr(elem, "colFirst"),
    colLast: xml.intAttr(elem, "colLast")
  };
}
function parseBookmarkEnd(elem, xml) {
  return {
    type: DomType.BookmarkEnd,
    id: xml.attr(elem, "id")
  };
}
var VmlElement = /*#__PURE__*/function (_OpenXmlElementBase3) {
  _inherits(VmlElement, _OpenXmlElementBase3);
  var _super20 = _createSuper(VmlElement);
  function VmlElement() {
    var _this11;
    _classCallCheck(this, VmlElement);
    _this11 = _super20.apply(this, arguments);
    _this11.type = DomType.VmlElement;
    _this11.attrs = {};
    return _this11;
  }
  return VmlElement;
}(OpenXmlElementBase);
function parseVmlElement(elem, parser) {
  var _result$children;
  var result = new VmlElement();
  switch (elem.localName) {
    case "rect":
      result.tagName = "rect";
      Object.assign(result.attrs, {
        width: '100%',
        height: '100%'
      });
      break;
    case "oval":
      result.tagName = "ellipse";
      Object.assign(result.attrs, {
        cx: "50%",
        cy: "50%",
        rx: "50%",
        ry: "50%"
      });
      break;
    case "line":
      result.tagName = "line";
      break;
    case "shape":
      result.tagName = "g";
      break;
    case "textbox":
      result.tagName = "foreignObject";
      Object.assign(result.attrs, {
        width: '100%',
        height: '100%'
      });
      break;
    default:
      return null;
  }
  var _iterator18 = _createForOfIteratorHelper(globalXmlParser.attrs(elem)),
    _step18;
  try {
    for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
      var at = _step18.value;
      switch (at.localName) {
        case "style":
          result.cssStyleText = at.value;
          break;
        case "fillcolor":
          result.attrs.fill = at.value;
          break;
        case "from":
          var _parsePoint = parsePoint(at.value),
            _parsePoint2 = _slicedToArray(_parsePoint, 2),
            x1 = _parsePoint2[0],
            y1 = _parsePoint2[1];
          Object.assign(result.attrs, {
            x1: x1,
            y1: y1
          });
          break;
        case "to":
          var _parsePoint3 = parsePoint(at.value),
            _parsePoint4 = _slicedToArray(_parsePoint3, 2),
            x2 = _parsePoint4[0],
            y2 = _parsePoint4[1];
          Object.assign(result.attrs, {
            x2: x2,
            y2: y2
          });
          break;
      }
    }
  } catch (err) {
    _iterator18.e(err);
  } finally {
    _iterator18.f();
  }
  var _iterator19 = _createForOfIteratorHelper(globalXmlParser.elements(elem)),
    _step19;
  try {
    for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
      var el = _step19.value;
      switch (el.localName) {
        case "stroke":
          Object.assign(result.attrs, parseStroke(el));
          break;
        case "fill":
          Object.assign(result.attrs, parseFill());
          break;
        case "imagedata":
          result.tagName = "image";
          Object.assign(result.attrs, {
            width: '100%',
            height: '100%'
          });
          result.imageHref = {
            id: globalXmlParser.attr(el, "id"),
            title: globalXmlParser.attr(el, "title")
          };
          break;
        case "txbxContent":
          (_result$children = result.children).push.apply(_result$children, _toConsumableArray(parser.parseBodyElements(el)));
          break;
        default:
          var child = parseVmlElement(el, parser);
          child && result.children.push(child);
          break;
      }
    }
  } catch (err) {
    _iterator19.e(err);
  } finally {
    _iterator19.f();
  }
  return result;
}
function parseStroke(el) {
  var _globalXmlParser$leng;
  return {
    'stroke': globalXmlParser.attr(el, "color"),
    'stroke-width': (_globalXmlParser$leng = globalXmlParser.lengthAttr(el, "weight", LengthUsage.Emu)) !== null && _globalXmlParser$leng !== void 0 ? _globalXmlParser$leng : '1px'
  };
}
function parseFill(el) {
  return {};
}
function parsePoint(val) {
  return val.split(",");
}
var WmlComment = /*#__PURE__*/function (_OpenXmlElementBase4) {
  _inherits(WmlComment, _OpenXmlElementBase4);
  var _super21 = _createSuper(WmlComment);
  function WmlComment() {
    var _this12;
    _classCallCheck(this, WmlComment);
    _this12 = _super21.apply(this, arguments);
    _this12.type = DomType.Comment;
    return _this12;
  }
  return WmlComment;
}(OpenXmlElementBase);
var WmlCommentReference = /*#__PURE__*/function (_OpenXmlElementBase5) {
  _inherits(WmlCommentReference, _OpenXmlElementBase5);
  var _super22 = _createSuper(WmlCommentReference);
  function WmlCommentReference(id) {
    var _this13;
    _classCallCheck(this, WmlCommentReference);
    _this13 = _super22.call(this);
    _this13.id = id;
    _this13.type = DomType.CommentReference;
    return _this13;
  }
  return WmlCommentReference;
}(OpenXmlElementBase);
var WmlCommentRangeStart = /*#__PURE__*/function (_OpenXmlElementBase6) {
  _inherits(WmlCommentRangeStart, _OpenXmlElementBase6);
  var _super23 = _createSuper(WmlCommentRangeStart);
  function WmlCommentRangeStart(id) {
    var _this14;
    _classCallCheck(this, WmlCommentRangeStart);
    _this14 = _super23.call(this);
    _this14.id = id;
    _this14.type = DomType.CommentRangeStart;
    return _this14;
  }
  return WmlCommentRangeStart;
}(OpenXmlElementBase);
var WmlCommentRangeEnd = /*#__PURE__*/function (_OpenXmlElementBase7) {
  _inherits(WmlCommentRangeEnd, _OpenXmlElementBase7);
  var _super24 = _createSuper(WmlCommentRangeEnd);
  function WmlCommentRangeEnd(id) {
    var _this15;
    _classCallCheck(this, WmlCommentRangeEnd);
    _this15 = _super24.call(this);
    _this15.id = id;
    _this15.type = DomType.CommentRangeEnd;
    return _this15;
  }
  return WmlCommentRangeEnd;
}(OpenXmlElementBase);
var autos = {
  shd: "inherit",
  color: "black",
  borderColor: "black",
  highlight: "transparent"
};
var supportedNamespaceURIs = [];
var mmlTagMap = {
  "oMath": DomType.MmlMath,
  "oMathPara": DomType.MmlMathParagraph,
  "f": DomType.MmlFraction,
  "func": DomType.MmlFunction,
  "fName": DomType.MmlFunctionName,
  "num": DomType.MmlNumerator,
  "den": DomType.MmlDenominator,
  "rad": DomType.MmlRadical,
  "deg": DomType.MmlDegree,
  "e": DomType.MmlBase,
  "sSup": DomType.MmlSuperscript,
  "sSub": DomType.MmlSubscript,
  "sPre": DomType.MmlPreSubSuper,
  "sup": DomType.MmlSuperArgument,
  "sub": DomType.MmlSubArgument,
  "d": DomType.MmlDelimiter,
  "nary": DomType.MmlNary,
  "eqArr": DomType.MmlEquationArray,
  "lim": DomType.MmlLimit,
  "limLow": DomType.MmlLimitLower,
  "m": DomType.MmlMatrix,
  "mr": DomType.MmlMatrixRow,
  "box": DomType.MmlBox,
  "bar": DomType.MmlBar,
  "groupChr": DomType.MmlGroupChar
};
var DocumentParser = /*#__PURE__*/function () {
  function DocumentParser(options) {
    _classCallCheck(this, DocumentParser);
    this.options = _objectSpread({
      ignoreWidth: false,
      debug: false
    }, options);
  }
  _createClass(DocumentParser, [{
    key: "parseNotes",
    value: function parseNotes(xmlDoc, elemName, elemClass) {
      var result = [];
      var _iterator20 = _createForOfIteratorHelper(globalXmlParser.elements(xmlDoc, elemName)),
        _step20;
      try {
        for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
          var el = _step20.value;
          var node = new elemClass();
          node.id = globalXmlParser.attr(el, "id");
          node.noteType = globalXmlParser.attr(el, "type");
          node.children = this.parseBodyElements(el);
          result.push(node);
        }
      } catch (err) {
        _iterator20.e(err);
      } finally {
        _iterator20.f();
      }
      return result;
    }
  }, {
    key: "parseComments",
    value: function parseComments(xmlDoc) {
      var result = [];
      var _iterator21 = _createForOfIteratorHelper(globalXmlParser.elements(xmlDoc, "comment")),
        _step21;
      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var el = _step21.value;
          var item = new WmlComment();
          item.id = globalXmlParser.attr(el, "id");
          item.author = globalXmlParser.attr(el, "author");
          item.initials = globalXmlParser.attr(el, "initials");
          item.date = globalXmlParser.attr(el, "date");
          item.children = this.parseBodyElements(el);
          result.push(item);
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }
      return result;
    }
  }, {
    key: "parseDocumentFile",
    value: function parseDocumentFile(xmlDoc) {
      var xbody = globalXmlParser.element(xmlDoc, "body");
      var background = globalXmlParser.element(xmlDoc, "background");
      var sectPr = globalXmlParser.element(xbody, "sectPr");
      return {
        type: DomType.Document,
        children: this.parseBodyElements(xbody),
        props: sectPr ? parseSectionProperties(sectPr, globalXmlParser) : {},
        cssStyle: background ? this.parseBackground(background) : {}
      };
    }
  }, {
    key: "parseBackground",
    value: function parseBackground(elem) {
      var result = {};
      var color = xmlUtil.colorAttr(elem, "color");
      if (color) {
        result["background-color"] = color;
      }
      return result;
    }
  }, {
    key: "parseBodyElements",
    value: function parseBodyElements(element) {
      var _this16 = this;
      var children = [];
      var _iterator22 = _createForOfIteratorHelper(globalXmlParser.elements(element)),
        _step22;
      try {
        for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
          var elem = _step22.value;
          switch (elem.localName) {
            case "p":
              children.push(this.parseParagraph(elem));
              break;
            case "altChunk":
              children.push(this.parseAltChunk(elem));
              break;
            case "tbl":
              children.push(this.parseTable(elem));
              break;
            case "sdt":
              children.push.apply(children, _toConsumableArray(this.parseSdt(elem, function (e) {
                return _this16.parseBodyElements(e);
              })));
              break;
          }
        }
      } catch (err) {
        _iterator22.e(err);
      } finally {
        _iterator22.f();
      }
      return children;
    }
  }, {
    key: "parseStylesFile",
    value: function parseStylesFile(xstyles) {
      var result = [];
      var _iterator23 = _createForOfIteratorHelper(globalXmlParser.elements(xstyles)),
        _step23;
      try {
        for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
          var n = _step23.value;
          switch (n.localName) {
            case "style":
              result.push(this.parseStyle(n));
              break;
            case "docDefaults":
              result.push(this.parseDefaultStyles(n));
              break;
          }
        }
      } catch (err) {
        _iterator23.e(err);
      } finally {
        _iterator23.f();
      }
      return result;
    }
  }, {
    key: "parseDefaultStyles",
    value: function parseDefaultStyles(node) {
      var result = {
        id: null,
        name: null,
        target: null,
        basedOn: null,
        styles: []
      };
      var _iterator24 = _createForOfIteratorHelper(globalXmlParser.elements(node)),
        _step24;
      try {
        for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
          var c = _step24.value;
          switch (c.localName) {
            case "rPrDefault":
              var rPr = globalXmlParser.element(c, "rPr");
              if (rPr) result.styles.push({
                target: "span",
                values: this.parseDefaultProperties(rPr, {})
              });
              break;
            case "pPrDefault":
              var pPr = globalXmlParser.element(c, "pPr");
              if (pPr) result.styles.push({
                target: "p",
                values: this.parseDefaultProperties(pPr, {})
              });
              break;
          }
        }
      } catch (err) {
        _iterator24.e(err);
      } finally {
        _iterator24.f();
      }
      return result;
    }
  }, {
    key: "parseStyle",
    value: function parseStyle(node) {
      var result = {
        id: globalXmlParser.attr(node, "styleId"),
        isDefault: globalXmlParser.boolAttr(node, "default"),
        name: null,
        target: null,
        basedOn: null,
        styles: [],
        linked: null
      };
      switch (globalXmlParser.attr(node, "type")) {
        case "paragraph":
          result.target = "p";
          break;
        case "table":
          result.target = "table";
          break;
        case "character":
          result.target = "span";
          break;
      }
      var _iterator25 = _createForOfIteratorHelper(globalXmlParser.elements(node)),
        _step25;
      try {
        for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
          var n = _step25.value;
          switch (n.localName) {
            case "basedOn":
              result.basedOn = globalXmlParser.attr(n, "val");
              break;
            case "name":
              result.name = globalXmlParser.attr(n, "val");
              break;
            case "link":
              result.linked = globalXmlParser.attr(n, "val");
              break;
            case "next":
              result.next = globalXmlParser.attr(n, "val");
              break;
            case "aliases":
              result.aliases = globalXmlParser.attr(n, "val").split(",");
              break;
            case "pPr":
              result.styles.push({
                target: "p",
                values: this.parseDefaultProperties(n, {})
              });
              result.paragraphProps = parseParagraphProperties(n, globalXmlParser);
              break;
            case "rPr":
              result.styles.push({
                target: "span",
                values: this.parseDefaultProperties(n, {})
              });
              result.runProps = parseRunProperties(n, globalXmlParser);
              break;
            case "tblPr":
            case "tcPr":
              result.styles.push({
                target: "td",
                values: this.parseDefaultProperties(n, {})
              });
              break;
            case "tblStylePr":
              var _iterator26 = _createForOfIteratorHelper(this.parseTableStyle(n)),
                _step26;
              try {
                for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
                  var s = _step26.value;
                  result.styles.push(s);
                }
              } catch (err) {
                _iterator26.e(err);
              } finally {
                _iterator26.f();
              }
              break;
            case "rsid":
            case "qFormat":
            case "hidden":
            case "semiHidden":
            case "unhideWhenUsed":
            case "autoRedefine":
            case "uiPriority":
              break;
            default:
              this.options.debug && console.warn("DOCX: Unknown style element: ".concat(n.localName));
          }
        }
      } catch (err) {
        _iterator25.e(err);
      } finally {
        _iterator25.f();
      }
      return result;
    }
  }, {
    key: "parseTableStyle",
    value: function parseTableStyle(node) {
      var result = [];
      var type = globalXmlParser.attr(node, "type");
      var selector = "";
      var modificator = "";
      switch (type) {
        case "firstRow":
          modificator = ".first-row";
          selector = "tr.first-row td";
          break;
        case "lastRow":
          modificator = ".last-row";
          selector = "tr.last-row td";
          break;
        case "firstCol":
          modificator = ".first-col";
          selector = "td.first-col";
          break;
        case "lastCol":
          modificator = ".last-col";
          selector = "td.last-col";
          break;
        case "band1Vert":
          modificator = ":not(.no-vband)";
          selector = "td.odd-col";
          break;
        case "band2Vert":
          modificator = ":not(.no-vband)";
          selector = "td.even-col";
          break;
        case "band1Horz":
          modificator = ":not(.no-hband)";
          selector = "tr.odd-row";
          break;
        case "band2Horz":
          modificator = ":not(.no-hband)";
          selector = "tr.even-row";
          break;
        default:
          return [];
      }
      var _iterator27 = _createForOfIteratorHelper(globalXmlParser.elements(node)),
        _step27;
      try {
        for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
          var n = _step27.value;
          switch (n.localName) {
            case "pPr":
              result.push({
                target: "".concat(selector, " p"),
                mod: modificator,
                values: this.parseDefaultProperties(n, {})
              });
              break;
            case "rPr":
              result.push({
                target: "".concat(selector, " span"),
                mod: modificator,
                values: this.parseDefaultProperties(n, {})
              });
              break;
            case "tblPr":
            case "tcPr":
              result.push({
                target: selector,
                mod: modificator,
                values: this.parseDefaultProperties(n, {})
              });
              break;
          }
        }
      } catch (err) {
        _iterator27.e(err);
      } finally {
        _iterator27.f();
      }
      return result;
    }
  }, {
    key: "parseNumberingFile",
    value: function parseNumberingFile(node) {
      var levels = [];
      var nums = [];
      var bullets = [];
      var _iterator28 = _createForOfIteratorHelper(globalXmlParser.elements(node)),
        _step28;
      try {
        for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
          var n = _step28.value;
          switch (n.localName) {
            case "abstractNum":
              levels.push.apply(levels, _toConsumableArray(this.parseAbstractNumbering(n, bullets)));
              break;
            case "numPicBullet":
              bullets.push(this.parseNumberingPicBullet(n));
              break;
            case "num":
              nums.push({
                numId: globalXmlParser.attr(n, "numId"),
                abstractNumId: globalXmlParser.elementAttr(n, "abstractNumId", "val")
              });
              break;
          }
        }
      } catch (err) {
        _iterator28.e(err);
      } finally {
        _iterator28.f();
      }
      return nums.flatMap(function (x) {
        return levels.filter(function (lvl) {
          return x.abstractNumId == lvl.id;
        }).map(function (lvl) {
          return _objectSpread(_objectSpread({}, lvl), {}, {
            id: x.numId
          });
        });
      });
    }
  }, {
    key: "parseNumberingPicBullet",
    value: function parseNumberingPicBullet(elem) {
      var pict = globalXmlParser.element(elem, "pict");
      var shape = pict && globalXmlParser.element(pict, "shape");
      var imagedata = shape && globalXmlParser.element(shape, "imagedata");
      return imagedata ? {
        id: globalXmlParser.intAttr(elem, "numPicBulletId"),
        src: globalXmlParser.attr(imagedata, "id"),
        style: globalXmlParser.attr(shape, "style")
      } : null;
    }
  }, {
    key: "parseAbstractNumbering",
    value: function parseAbstractNumbering(node, bullets) {
      var result = [];
      var id = globalXmlParser.attr(node, "abstractNumId");
      var _iterator29 = _createForOfIteratorHelper(globalXmlParser.elements(node)),
        _step29;
      try {
        for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
          var n = _step29.value;
          switch (n.localName) {
            case "lvl":
              result.push(this.parseNumberingLevel(id, n, bullets));
              break;
          }
        }
      } catch (err) {
        _iterator29.e(err);
      } finally {
        _iterator29.f();
      }
      return result;
    }
  }, {
    key: "parseNumberingLevel",
    value: function parseNumberingLevel(id, node, bullets) {
      var result = {
        id: id,
        level: globalXmlParser.intAttr(node, "ilvl"),
        start: 1,
        pStyleName: undefined,
        pStyle: {},
        rStyle: {},
        suff: "tab"
      };
      var _iterator30 = _createForOfIteratorHelper(globalXmlParser.elements(node)),
        _step30;
      try {
        for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
          var n = _step30.value;
          switch (n.localName) {
            case "start":
              result.start = globalXmlParser.intAttr(n, "val");
              break;
            case "pPr":
              this.parseDefaultProperties(n, result.pStyle);
              break;
            case "rPr":
              this.parseDefaultProperties(n, result.rStyle);
              break;
            case "lvlPicBulletId":
              var bulletId = globalXmlParser.intAttr(n, "val");
              result.bullet = bullets.find(function (x) {
                return (x === null || x === void 0 ? void 0 : x.id) == bulletId;
              });
              break;
            case "lvlText":
              result.levelText = globalXmlParser.attr(n, "val");
              break;
            case "pStyle":
              result.pStyleName = globalXmlParser.attr(n, "val");
              break;
            case "numFmt":
              result.format = globalXmlParser.attr(n, "val");
              break;
            case "suff":
              result.suff = globalXmlParser.attr(n, "val");
              break;
          }
        }
      } catch (err) {
        _iterator30.e(err);
      } finally {
        _iterator30.f();
      }
      return result;
    }
  }, {
    key: "parseSdt",
    value: function parseSdt(node, parser) {
      var sdtContent = globalXmlParser.element(node, "sdtContent");
      return sdtContent ? parser(sdtContent) : [];
    }
  }, {
    key: "parseChange",
    value: function parseChange(type, node, parentParser) {
      var _parentParser$childre, _parentParser;
      return {
        type: type,
        children: (_parentParser$childre = (_parentParser = parentParser(node)) === null || _parentParser === void 0 ? void 0 : _parentParser.children) !== null && _parentParser$childre !== void 0 ? _parentParser$childre : [],
        id: globalXmlParser.attr(node, "id"),
        author: globalXmlParser.attr(node, "author"),
        date: globalXmlParser.attr(node, "date")
      };
    }
  }, {
    key: "parseAltChunk",
    value: function parseAltChunk(node) {
      return {
        type: DomType.AltChunk,
        children: [],
        id: globalXmlParser.attr(node, "id")
      };
    }
  }, {
    key: "parseParagraph",
    value: function parseParagraph(node) {
      var _result$children2,
        _this17 = this;
      var result = {
        type: DomType.Paragraph,
        children: []
      };
      var _iterator31 = _createForOfIteratorHelper(globalXmlParser.elements(node)),
        _step31;
      try {
        for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
          var el = _step31.value;
          switch (el.localName) {
            case "pPr":
              this.parseParagraphProperties(el, result);
              break;
            case "r":
              result.children.push(this.parseRun(el, result));
              break;
            case "hyperlink":
              result.children.push(this.parseHyperlink(el, result));
              break;
            case "smartTag":
              result.children.push(this.parseSmartTag(el, result));
              break;
            case "bookmarkStart":
              result.children.push(parseBookmarkStart(el, globalXmlParser));
              break;
            case "bookmarkEnd":
              result.children.push(parseBookmarkEnd(el, globalXmlParser));
              break;
            case "commentRangeStart":
              result.children.push(new WmlCommentRangeStart(globalXmlParser.attr(el, "id")));
              break;
            case "commentRangeEnd":
              result.children.push(new WmlCommentRangeEnd(globalXmlParser.attr(el, "id")));
              break;
            case "oMath":
            case "oMathPara":
              result.children.push(this.parseMathElement(el));
              break;
            case "sdt":
              (_result$children2 = result.children).push.apply(_result$children2, _toConsumableArray(this.parseSdt(el, function (e) {
                return _this17.parseParagraph(e).children;
              })));
              break;
            case "ins":
              result.children.push(this.parseChange(DomType.Inserted, el, function (e) {
                return _this17.parseParagraph(e);
              }));
              break;
            case "del":
              result.children.push(this.parseChange(DomType.Deleted, el, function (e) {
                return _this17.parseParagraph(e);
              }));
              break;
          }
        }
      } catch (err) {
        _iterator31.e(err);
      } finally {
        _iterator31.f();
      }
      return result;
    }
  }, {
    key: "parseParagraphProperties",
    value: function parseParagraphProperties(elem, paragraph) {
      var _this18 = this;
      this.parseDefaultProperties(elem, paragraph.cssStyle = {}, null, function (c) {
        if (parseParagraphProperty(c, paragraph, globalXmlParser)) return true;
        switch (c.localName) {
          case "pStyle":
            paragraph.styleName = globalXmlParser.attr(c, "val");
            break;
          case "cnfStyle":
            paragraph.className = values.classNameOfCnfStyle(c);
            break;
          case "framePr":
            _this18.parseFrame(c, paragraph);
            break;
          case "rPr":
            break;
          default:
            return false;
        }
        return true;
      });
    }
  }, {
    key: "parseFrame",
    value: function parseFrame(node, paragraph) {
      var dropCap = globalXmlParser.attr(node, "dropCap");
      if (dropCap == "drop") paragraph.cssStyle["float"] = "left";
    }
  }, {
    key: "parseHyperlink",
    value: function parseHyperlink(node, parent) {
      var result = {
        type: DomType.Hyperlink,
        parent: parent,
        children: []
      };
      result.anchor = globalXmlParser.attr(node, "anchor");
      result.id = globalXmlParser.attr(node, "id");
      var _iterator32 = _createForOfIteratorHelper(globalXmlParser.elements(node)),
        _step32;
      try {
        for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
          var c = _step32.value;
          switch (c.localName) {
            case "r":
              result.children.push(this.parseRun(c, result));
              break;
          }
        }
      } catch (err) {
        _iterator32.e(err);
      } finally {
        _iterator32.f();
      }
      return result;
    }
  }, {
    key: "parseSmartTag",
    value: function parseSmartTag(node, parent) {
      var result = {
        type: DomType.SmartTag,
        parent: parent,
        children: []
      };
      var uri = globalXmlParser.attr(node, "uri");
      var element = globalXmlParser.attr(node, "element");
      if (uri) result.uri = uri;
      if (element) result.element = element;
      var _iterator33 = _createForOfIteratorHelper(globalXmlParser.elements(node)),
        _step33;
      try {
        for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
          var c = _step33.value;
          switch (c.localName) {
            case "r":
              result.children.push(this.parseRun(c, result));
              break;
            case "smartTag":
              result.children.push(this.parseSmartTag(c, result));
              break;
          }
        }
      } catch (err) {
        _iterator33.e(err);
      } finally {
        _iterator33.f();
      }
      return result;
    }
  }, {
    key: "parseRun",
    value: function parseRun(node, parent) {
      var result = {
        type: DomType.Run,
        parent: parent,
        children: []
      };
      var _iterator34 = _createForOfIteratorHelper(globalXmlParser.elements(node)),
        _step34;
      try {
        for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
          var _c;
          var c = _step34.value;
          c = this.checkAlternateContent(c);
          switch ((_c = c) === null || _c === void 0 ? void 0 : _c.localName) {
            case "t":
              result.children.push({
                type: DomType.Text,
                text: c.textContent
              });
              break;
            case "delText":
              result.children.push({
                type: DomType.DeletedText,
                text: c.textContent
              });
              break;
            case "commentReference":
              result.children.push(new WmlCommentReference(globalXmlParser.attr(c, "id")));
              break;
            case "fldSimple":
              result.children.push({
                type: DomType.SimpleField,
                instruction: globalXmlParser.attr(c, "instr"),
                lock: globalXmlParser.boolAttr(c, "lock", false),
                dirty: globalXmlParser.boolAttr(c, "dirty", false)
              });
              break;
            case "instrText":
              result.fieldRun = true;
              result.children.push({
                type: DomType.Instruction,
                text: c.textContent
              });
              break;
            case "fldChar":
              result.fieldRun = true;
              result.children.push({
                type: DomType.ComplexField,
                charType: globalXmlParser.attr(c, "fldCharType"),
                lock: globalXmlParser.boolAttr(c, "lock", false),
                dirty: globalXmlParser.boolAttr(c, "dirty", false)
              });
              break;
            case "noBreakHyphen":
              result.children.push({
                type: DomType.NoBreakHyphen
              });
              break;
            case "br":
              result.children.push({
                type: DomType.Break,
                break: globalXmlParser.attr(c, "type") || "textWrapping"
              });
              break;
            case "lastRenderedPageBreak":
              result.children.push({
                type: DomType.Break,
                break: "lastRenderedPageBreak"
              });
              break;
            case "sym":
              result.children.push({
                type: DomType.Symbol,
                font: encloseFontFamily(globalXmlParser.attr(c, "font")),
                char: globalXmlParser.hexAttr(c, "char")
              });
              break;
            case "tab":
              result.children.push({
                type: DomType.Tab
              });
              break;
            case "footnoteReference":
              result.children.push({
                type: DomType.FootnoteReference,
                id: globalXmlParser.attr(c, "id")
              });
              break;
            case "endnoteReference":
              result.children.push({
                type: DomType.EndnoteReference,
                id: globalXmlParser.attr(c, "id")
              });
              break;
            case "drawing":
              var d = this.parseDrawing(c);
              if (d) result.children.push(d);
              break;
            case "pict":
              result.children.push(this.parseVmlPicture(c));
              break;
            case "rPr":
              this.parseRunProperties(c, result);
              break;
          }
        }
      } catch (err) {
        _iterator34.e(err);
      } finally {
        _iterator34.f();
      }
      return result;
    }
  }, {
    key: "parseMathElement",
    value: function parseMathElement(elem) {
      var propsTag = "".concat(elem.localName, "Pr");
      var result = {
        type: mmlTagMap[elem.localName],
        children: []
      };
      var _iterator35 = _createForOfIteratorHelper(globalXmlParser.elements(elem)),
        _step35;
      try {
        for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
          var el = _step35.value;
          var childType = mmlTagMap[el.localName];
          if (childType) {
            result.children.push(this.parseMathElement(el));
          } else if (el.localName == "r") {
            var run = this.parseRun(el);
            run.type = DomType.MmlRun;
            result.children.push(run);
          } else if (el.localName == propsTag) {
            result.props = this.parseMathProperies(el);
          }
        }
      } catch (err) {
        _iterator35.e(err);
      } finally {
        _iterator35.f();
      }
      return result;
    }
  }, {
    key: "parseMathProperies",
    value: function parseMathProperies(elem) {
      var result = {};
      var _iterator36 = _createForOfIteratorHelper(globalXmlParser.elements(elem)),
        _step36;
      try {
        for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
          var el = _step36.value;
          switch (el.localName) {
            case "chr":
              result.char = globalXmlParser.attr(el, "val");
              break;
            case "vertJc":
              result.verticalJustification = globalXmlParser.attr(el, "val");
              break;
            case "pos":
              result.position = globalXmlParser.attr(el, "val");
              break;
            case "degHide":
              result.hideDegree = globalXmlParser.boolAttr(el, "val");
              break;
            case "begChr":
              result.beginChar = globalXmlParser.attr(el, "val");
              break;
            case "endChr":
              result.endChar = globalXmlParser.attr(el, "val");
              break;
          }
        }
      } catch (err) {
        _iterator36.e(err);
      } finally {
        _iterator36.f();
      }
      return result;
    }
  }, {
    key: "parseRunProperties",
    value: function parseRunProperties(elem, run) {
      this.parseDefaultProperties(elem, run.cssStyle = {}, null, function (c) {
        switch (c.localName) {
          case "rStyle":
            run.styleName = globalXmlParser.attr(c, "val");
            break;
          case "vertAlign":
            run.verticalAlign = values.valueOfVertAlign(c, true);
            break;
          default:
            return false;
        }
        return true;
      });
    }
  }, {
    key: "parseVmlPicture",
    value: function parseVmlPicture(elem) {
      var result = {
        type: DomType.VmlPicture,
        children: []
      };
      var _iterator37 = _createForOfIteratorHelper(globalXmlParser.elements(elem)),
        _step37;
      try {
        for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
          var el = _step37.value;
          var child = parseVmlElement(el, this);
          child && result.children.push(child);
        }
      } catch (err) {
        _iterator37.e(err);
      } finally {
        _iterator37.f();
      }
      return result;
    }
  }, {
    key: "checkAlternateContent",
    value: function checkAlternateContent(elem) {
      var _globalXmlParser$elem;
      if (elem.localName != 'AlternateContent') return elem;
      var choice = globalXmlParser.element(elem, "Choice");
      if (choice) {
        var requires = globalXmlParser.attr(choice, "Requires");
        var namespaceURI = elem.lookupNamespaceURI(requires);
        if (supportedNamespaceURIs.includes(namespaceURI)) return choice.firstElementChild;
      }
      return (_globalXmlParser$elem = globalXmlParser.element(elem, "Fallback")) === null || _globalXmlParser$elem === void 0 ? void 0 : _globalXmlParser$elem.firstElementChild;
    }
  }, {
    key: "parseDrawing",
    value: function parseDrawing(node) {
      var _iterator38 = _createForOfIteratorHelper(globalXmlParser.elements(node)),
        _step38;
      try {
        for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
          var n = _step38.value;
          switch (n.localName) {
            case "inline":
            case "anchor":
              return this.parseDrawingWrapper(n);
          }
        }
      } catch (err) {
        _iterator38.e(err);
      } finally {
        _iterator38.f();
      }
    }
  }, {
    key: "parseDrawingWrapper",
    value: function parseDrawingWrapper(node) {
      var result = {
        type: DomType.Drawing,
        children: [],
        cssStyle: {}
      };
      var isAnchor = node.localName == "anchor";
      var wrapType = null;
      var simplePos = globalXmlParser.boolAttr(node, "simplePos");
      globalXmlParser.boolAttr(node, "behindDoc");
      var posX = {
        relative: "page",
        align: "left",
        offset: "0"
      };
      var posY = {
        relative: "page",
        align: "top",
        offset: "0"
      };
      var _iterator39 = _createForOfIteratorHelper(globalXmlParser.elements(node)),
        _step39;
      try {
        for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
          var n = _step39.value;
          switch (n.localName) {
            case "simplePos":
              if (simplePos) {
                posX.offset = globalXmlParser.lengthAttr(n, "x", LengthUsage.Emu);
                posY.offset = globalXmlParser.lengthAttr(n, "y", LengthUsage.Emu);
              }
              break;
            case "extent":
              result.cssStyle["width"] = globalXmlParser.lengthAttr(n, "cx", LengthUsage.Emu);
              result.cssStyle["height"] = globalXmlParser.lengthAttr(n, "cy", LengthUsage.Emu);
              break;
            case "positionH":
            case "positionV":
              if (!simplePos) {
                var _globalXmlParser$attr;
                var pos = n.localName == "positionH" ? posX : posY;
                var alignNode = globalXmlParser.element(n, "align");
                var offsetNode = globalXmlParser.element(n, "posOffset");
                pos.relative = (_globalXmlParser$attr = globalXmlParser.attr(n, "relativeFrom")) !== null && _globalXmlParser$attr !== void 0 ? _globalXmlParser$attr : pos.relative;
                if (alignNode) pos.align = alignNode.textContent;
                if (offsetNode) pos.offset = convertLength(offsetNode.textContent, LengthUsage.Emu);
              }
              break;
            case "wrapTopAndBottom":
              wrapType = "wrapTopAndBottom";
              break;
            case "wrapNone":
              wrapType = "wrapNone";
              break;
            case "graphic":
              var g = this.parseGraphic(n);
              if (g) result.children.push(g);
              break;
          }
        }
      } catch (err) {
        _iterator39.e(err);
      } finally {
        _iterator39.f();
      }
      if (wrapType == "wrapTopAndBottom") {
        result.cssStyle['display'] = 'block';
        if (posX.align) {
          result.cssStyle['text-align'] = posX.align;
          result.cssStyle['width'] = "100%";
        }
      } else if (wrapType == "wrapNone") {
        result.cssStyle['display'] = 'block';
        result.cssStyle['position'] = 'relative';
        result.cssStyle["width"] = "0px";
        result.cssStyle["height"] = "0px";
        if (posX.offset) result.cssStyle["left"] = posX.offset;
        if (posY.offset) result.cssStyle["top"] = posY.offset;
      } else if (isAnchor && (posX.align == 'left' || posX.align == 'right')) {
        result.cssStyle["float"] = posX.align;
      }
      return result;
    }
  }, {
    key: "parseGraphic",
    value: function parseGraphic(elem) {
      var graphicData = globalXmlParser.element(elem, "graphicData");
      var _iterator40 = _createForOfIteratorHelper(globalXmlParser.elements(graphicData)),
        _step40;
      try {
        for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
          var n = _step40.value;
          switch (n.localName) {
            case "pic":
              return this.parsePicture(n);
          }
        }
      } catch (err) {
        _iterator40.e(err);
      } finally {
        _iterator40.f();
      }
      return null;
    }
  }, {
    key: "parsePicture",
    value: function parsePicture(elem) {
      var result = {
        type: DomType.Image,
        src: "",
        cssStyle: {}
      };
      var blipFill = globalXmlParser.element(elem, "blipFill");
      var blip = globalXmlParser.element(blipFill, "blip");
      var srcRect = globalXmlParser.element(blipFill, "srcRect");
      result.src = globalXmlParser.attr(blip, "embed");
      if (srcRect) {
        result.srcRect = [globalXmlParser.intAttr(srcRect, "l", 0) / 100000, globalXmlParser.intAttr(srcRect, "t", 0) / 100000, globalXmlParser.intAttr(srcRect, "r", 0) / 100000, globalXmlParser.intAttr(srcRect, "b", 0) / 100000];
      }
      var spPr = globalXmlParser.element(elem, "spPr");
      var xfrm = globalXmlParser.element(spPr, "xfrm");
      result.cssStyle["position"] = "relative";
      if (xfrm) {
        result.rotation = globalXmlParser.intAttr(xfrm, "rot", 0) / 60000;
        var _iterator41 = _createForOfIteratorHelper(globalXmlParser.elements(xfrm)),
          _step41;
        try {
          for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
            var n = _step41.value;
            switch (n.localName) {
              case "ext":
                result.cssStyle["width"] = globalXmlParser.lengthAttr(n, "cx", LengthUsage.Emu);
                result.cssStyle["height"] = globalXmlParser.lengthAttr(n, "cy", LengthUsage.Emu);
                break;
              case "off":
                result.cssStyle["left"] = globalXmlParser.lengthAttr(n, "x", LengthUsage.Emu);
                result.cssStyle["top"] = globalXmlParser.lengthAttr(n, "y", LengthUsage.Emu);
                break;
            }
          }
        } catch (err) {
          _iterator41.e(err);
        } finally {
          _iterator41.f();
        }
      }
      return result;
    }
  }, {
    key: "parseTable",
    value: function parseTable(node) {
      var result = {
        type: DomType.Table,
        children: []
      };
      var _iterator42 = _createForOfIteratorHelper(globalXmlParser.elements(node)),
        _step42;
      try {
        for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
          var c = _step42.value;
          switch (c.localName) {
            case "tr":
              result.children.push(this.parseTableRow(c));
              break;
            case "tblGrid":
              result.columns = this.parseTableColumns(c);
              break;
            case "tblPr":
              this.parseTableProperties(c, result);
              break;
          }
        }
      } catch (err) {
        _iterator42.e(err);
      } finally {
        _iterator42.f();
      }
      return result;
    }
  }, {
    key: "parseTableColumns",
    value: function parseTableColumns(node) {
      var result = [];
      var _iterator43 = _createForOfIteratorHelper(globalXmlParser.elements(node)),
        _step43;
      try {
        for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
          var n = _step43.value;
          switch (n.localName) {
            case "gridCol":
              result.push({
                width: globalXmlParser.lengthAttr(n, "w")
              });
              break;
          }
        }
      } catch (err) {
        _iterator43.e(err);
      } finally {
        _iterator43.f();
      }
      return result;
    }
  }, {
    key: "parseTableProperties",
    value: function parseTableProperties(elem, table) {
      var _this19 = this;
      table.cssStyle = {};
      table.cellStyle = {};
      this.parseDefaultProperties(elem, table.cssStyle, table.cellStyle, function (c) {
        switch (c.localName) {
          case "tblStyle":
            table.styleName = globalXmlParser.attr(c, "val");
            break;
          case "tblLook":
            table.className = values.classNameOftblLook(c);
            break;
          case "tblpPr":
            _this19.parseTablePosition(c, table);
            break;
          case "tblStyleColBandSize":
            table.colBandSize = globalXmlParser.intAttr(c, "val");
            break;
          case "tblStyleRowBandSize":
            table.rowBandSize = globalXmlParser.intAttr(c, "val");
            break;
          case "hidden":
            table.cssStyle["display"] = "none";
            break;
          default:
            return false;
        }
        return true;
      });
      switch (table.cssStyle["text-align"]) {
        case "center":
          delete table.cssStyle["text-align"];
          table.cssStyle["margin-left"] = "auto";
          table.cssStyle["margin-right"] = "auto";
          break;
        case "right":
          delete table.cssStyle["text-align"];
          table.cssStyle["margin-left"] = "auto";
          break;
      }
    }
  }, {
    key: "parseTablePosition",
    value: function parseTablePosition(node, table) {
      var topFromText = globalXmlParser.lengthAttr(node, "topFromText");
      var bottomFromText = globalXmlParser.lengthAttr(node, "bottomFromText");
      var rightFromText = globalXmlParser.lengthAttr(node, "rightFromText");
      var leftFromText = globalXmlParser.lengthAttr(node, "leftFromText");
      table.cssStyle["float"] = 'left';
      table.cssStyle["margin-bottom"] = values.addSize(table.cssStyle["margin-bottom"], bottomFromText);
      table.cssStyle["margin-left"] = values.addSize(table.cssStyle["margin-left"], leftFromText);
      table.cssStyle["margin-right"] = values.addSize(table.cssStyle["margin-right"], rightFromText);
      table.cssStyle["margin-top"] = values.addSize(table.cssStyle["margin-top"], topFromText);
    }
  }, {
    key: "parseTableRow",
    value: function parseTableRow(node) {
      var result = {
        type: DomType.Row,
        children: []
      };
      var _iterator44 = _createForOfIteratorHelper(globalXmlParser.elements(node)),
        _step44;
      try {
        for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
          var c = _step44.value;
          switch (c.localName) {
            case "tc":
              result.children.push(this.parseTableCell(c));
              break;
            case "trPr":
            case "tblPrEx":
              this.parseTableRowProperties(c, result);
              break;
          }
        }
      } catch (err) {
        _iterator44.e(err);
      } finally {
        _iterator44.f();
      }
      return result;
    }
  }, {
    key: "parseTableRowProperties",
    value: function parseTableRowProperties(elem, row) {
      row.cssStyle = this.parseDefaultProperties(elem, {}, null, function (c) {
        switch (c.localName) {
          case "cnfStyle":
            row.className = values.classNameOfCnfStyle(c);
            break;
          case "tblHeader":
            row.isHeader = globalXmlParser.boolAttr(c, "val");
            break;
          case "gridBefore":
            row.gridBefore = globalXmlParser.intAttr(c, "val");
            break;
          case "gridAfter":
            row.gridAfter = globalXmlParser.intAttr(c, "val");
            break;
          default:
            return false;
        }
        return true;
      });
    }
  }, {
    key: "parseTableCell",
    value: function parseTableCell(node) {
      var result = {
        type: DomType.Cell,
        children: []
      };
      var _iterator45 = _createForOfIteratorHelper(globalXmlParser.elements(node)),
        _step45;
      try {
        for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
          var c = _step45.value;
          switch (c.localName) {
            case "tbl":
              result.children.push(this.parseTable(c));
              break;
            case "p":
              result.children.push(this.parseParagraph(c));
              break;
            case "tcPr":
              this.parseTableCellProperties(c, result);
              break;
          }
        }
      } catch (err) {
        _iterator45.e(err);
      } finally {
        _iterator45.f();
      }
      return result;
    }
  }, {
    key: "parseTableCellProperties",
    value: function parseTableCellProperties(elem, cell) {
      cell.cssStyle = this.parseDefaultProperties(elem, {}, null, function (c) {
        var _globalXmlParser$attr2;
        switch (c.localName) {
          case "gridSpan":
            cell.span = globalXmlParser.intAttr(c, "val", null);
            break;
          case "vMerge":
            cell.verticalMerge = (_globalXmlParser$attr2 = globalXmlParser.attr(c, "val")) !== null && _globalXmlParser$attr2 !== void 0 ? _globalXmlParser$attr2 : "continue";
            break;
          case "cnfStyle":
            cell.className = values.classNameOfCnfStyle(c);
            break;
          default:
            return false;
        }
        return true;
      });
      this.parseTableCellVerticalText(elem, cell);
    }
  }, {
    key: "parseTableCellVerticalText",
    value: function parseTableCellVerticalText(elem, cell) {
      var directionMap = {
        "btLr": {
          writingMode: "vertical-rl",
          transform: "rotate(180deg)"
        },
        "lrTb": {
          writingMode: "vertical-lr",
          transform: "none"
        },
        "tbRl": {
          writingMode: "vertical-rl",
          transform: "none"
        }
      };
      var _iterator46 = _createForOfIteratorHelper(globalXmlParser.elements(elem)),
        _step46;
      try {
        for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
          var c = _step46.value;
          if (c.localName === "textDirection") {
            var direction = globalXmlParser.attr(c, "val");
            var style = directionMap[direction] || {
              writingMode: "horizontal-tb"
            };
            cell.cssStyle["writing-mode"] = style.writingMode;
            cell.cssStyle["transform"] = style.transform;
          }
        }
      } catch (err) {
        _iterator46.e(err);
      } finally {
        _iterator46.f();
      }
    }
  }, {
    key: "parseDefaultProperties",
    value: function parseDefaultProperties(elem) {
      var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var childStyle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var handler = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      style = style || {};
      var _iterator47 = _createForOfIteratorHelper(globalXmlParser.elements(elem)),
        _step47;
      try {
        for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
          var c = _step47.value;
          if (handler !== null && handler !== void 0 && handler(c)) continue;
          switch (c.localName) {
            case "jc":
              style["text-align"] = values.valueOfJc(c);
              break;
            case "textAlignment":
              style["vertical-align"] = values.valueOfTextAlignment(c);
              break;
            case "color":
              style["color"] = xmlUtil.colorAttr(c, "val", null, autos.color);
              break;
            case "sz":
              style["font-size"] = style["min-height"] = globalXmlParser.lengthAttr(c, "val", LengthUsage.FontSize);
              break;
            case "shd":
              style["background-color"] = xmlUtil.colorAttr(c, "fill", null, autos.shd);
              break;
            case "highlight":
              style["background-color"] = xmlUtil.colorAttr(c, "val", null, autos.highlight);
              break;
            case "vertAlign":
              break;
            case "position":
              style.verticalAlign = globalXmlParser.lengthAttr(c, "val", LengthUsage.FontSize);
              break;
            case "tcW":
              if (this.options.ignoreWidth) break;
            case "tblW":
              style["width"] = values.valueOfSize(c, "w");
              break;
            case "trHeight":
              this.parseTrHeight(c, style);
              break;
            case "strike":
              style["text-decoration"] = globalXmlParser.boolAttr(c, "val", true) ? "line-through" : "none";
              break;
            case "b":
              style["font-weight"] = globalXmlParser.boolAttr(c, "val", true) ? "bold" : "normal";
              break;
            case "i":
              style["font-style"] = globalXmlParser.boolAttr(c, "val", true) ? "italic" : "normal";
              break;
            case "caps":
              style["text-transform"] = globalXmlParser.boolAttr(c, "val", true) ? "uppercase" : "none";
              break;
            case "smallCaps":
              style["font-variant"] = globalXmlParser.boolAttr(c, "val", true) ? "small-caps" : "none";
              break;
            case "u":
              this.parseUnderline(c, style);
              break;
            case "ind":
            case "tblInd":
              this.parseIndentation(c, style);
              break;
            case "rFonts":
              this.parseFont(c, style);
              break;
            case "tblBorders":
              this.parseBorderProperties(c, childStyle || style);
              break;
            case "tblCellSpacing":
              style["border-spacing"] = values.valueOfMargin(c);
              style["border-collapse"] = "separate";
              break;
            case "pBdr":
              this.parseBorderProperties(c, style);
              break;
            case "bdr":
              style["border"] = values.valueOfBorder(c);
              break;
            case "tcBorders":
              this.parseBorderProperties(c, style);
              break;
            case "vanish":
              if (globalXmlParser.boolAttr(c, "val", true)) style["display"] = "none";
              break;
            case "kern":
              break;
            case "noWrap":
              break;
            case "tblCellMar":
            case "tcMar":
              this.parseMarginProperties(c, childStyle || style);
              break;
            case "tblLayout":
              style["table-layout"] = values.valueOfTblLayout(c);
              break;
            case "vAlign":
              style["vertical-align"] = values.valueOfTextAlignment(c);
              break;
            case "spacing":
              if (elem.localName == "pPr") this.parseSpacing(c, style);
              break;
            case "wordWrap":
              if (globalXmlParser.boolAttr(c, "val")) style["overflow-wrap"] = "break-word";
              break;
            case "suppressAutoHyphens":
              style["hyphens"] = globalXmlParser.boolAttr(c, "val", true) ? "none" : "auto";
              break;
            case "lang":
              style["$lang"] = globalXmlParser.attr(c, "val");
              break;
            case "rtl":
            case "bidi":
              if (globalXmlParser.boolAttr(c, "val", true)) style["direction"] = "rtl";
              break;
            case "bCs":
            case "iCs":
            case "szCs":
            case "tabs":
            case "outlineLvl":
            case "contextualSpacing":
            case "tblStyleColBandSize":
            case "tblStyleRowBandSize":
            case "webHidden":
            case "pageBreakBefore":
            case "suppressLineNumbers":
            case "keepLines":
            case "keepNext":
            case "widowControl":
            case "noProof":
              break;
            default:
              if (this.options.debug) console.warn("DOCX: Unknown document element: ".concat(elem.localName, ".").concat(c.localName));
              break;
          }
        }
      } catch (err) {
        _iterator47.e(err);
      } finally {
        _iterator47.f();
      }
      return style;
    }
  }, {
    key: "parseUnderline",
    value: function parseUnderline(node, style) {
      var val = globalXmlParser.attr(node, "val");
      if (val == null) return;
      switch (val) {
        case "dash":
        case "dashDotDotHeavy":
        case "dashDotHeavy":
        case "dashedHeavy":
        case "dashLong":
        case "dashLongHeavy":
        case "dotDash":
        case "dotDotDash":
          style["text-decoration"] = "underline dashed";
          break;
        case "dotted":
        case "dottedHeavy":
          style["text-decoration"] = "underline dotted";
          break;
        case "double":
          style["text-decoration"] = "underline double";
          break;
        case "single":
        case "thick":
          style["text-decoration"] = "underline";
          break;
        case "wave":
        case "wavyDouble":
        case "wavyHeavy":
          style["text-decoration"] = "underline wavy";
          break;
        case "words":
          style["text-decoration"] = "underline";
          break;
        case "none":
          style["text-decoration"] = "none";
          break;
      }
      var col = xmlUtil.colorAttr(node, "color");
      if (col) style["text-decoration-color"] = col;
    }
  }, {
    key: "parseFont",
    value: function parseFont(node, style) {
      var ascii = globalXmlParser.attr(node, "ascii");
      var asciiTheme = values.themeValue(node, "asciiTheme");
      var eastAsia = globalXmlParser.attr(node, "eastAsia");
      var fonts = [ascii, asciiTheme, eastAsia].filter(function (x) {
        return x;
      }).map(function (x) {
        return encloseFontFamily(x);
      });
      if (fonts.length > 0) style["font-family"] = _toConsumableArray(new Set(fonts)).join(', ');
    }
  }, {
    key: "parseIndentation",
    value: function parseIndentation(node, style) {
      var firstLine = globalXmlParser.lengthAttr(node, "firstLine");
      var hanging = globalXmlParser.lengthAttr(node, "hanging");
      var left = globalXmlParser.lengthAttr(node, "left");
      var start = globalXmlParser.lengthAttr(node, "start");
      var right = globalXmlParser.lengthAttr(node, "right");
      var end = globalXmlParser.lengthAttr(node, "end");
      if (firstLine) style["text-indent"] = firstLine;
      if (hanging) style["text-indent"] = "-".concat(hanging);
      if (left || start) style["margin-inline-start"] = left || start;
      if (right || end) style["margin-inline-end"] = right || end;
    }
  }, {
    key: "parseSpacing",
    value: function parseSpacing(node, style) {
      var before = globalXmlParser.lengthAttr(node, "before");
      var after = globalXmlParser.lengthAttr(node, "after");
      var line = globalXmlParser.intAttr(node, "line", null);
      var lineRule = globalXmlParser.attr(node, "lineRule");
      if (before) style["margin-top"] = before;
      if (after) style["margin-bottom"] = after;
      if (line !== null) {
        switch (lineRule) {
          case "auto":
            style["line-height"] = "".concat((line / 240).toFixed(2));
            break;
          case "atLeast":
            style["line-height"] = "calc(100% + ".concat(line / 20, "pt)");
            break;
          default:
            style["line-height"] = style["min-height"] = "".concat(line / 20, "pt");
            break;
        }
      }
    }
  }, {
    key: "parseMarginProperties",
    value: function parseMarginProperties(node, output) {
      var _iterator48 = _createForOfIteratorHelper(globalXmlParser.elements(node)),
        _step48;
      try {
        for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
          var c = _step48.value;
          switch (c.localName) {
            case "left":
              output["padding-left"] = values.valueOfMargin(c);
              break;
            case "right":
              output["padding-right"] = values.valueOfMargin(c);
              break;
            case "top":
              output["padding-top"] = values.valueOfMargin(c);
              break;
            case "bottom":
              output["padding-bottom"] = values.valueOfMargin(c);
              break;
          }
        }
      } catch (err) {
        _iterator48.e(err);
      } finally {
        _iterator48.f();
      }
    }
  }, {
    key: "parseTrHeight",
    value: function parseTrHeight(node, output) {
      switch (globalXmlParser.attr(node, "hRule")) {
        case "exact":
          output["height"] = globalXmlParser.lengthAttr(node, "val");
          break;
        case "atLeast":
        default:
          output["height"] = globalXmlParser.lengthAttr(node, "val");
          break;
      }
    }
  }, {
    key: "parseBorderProperties",
    value: function parseBorderProperties(node, output) {
      var _iterator49 = _createForOfIteratorHelper(globalXmlParser.elements(node)),
        _step49;
      try {
        for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
          var c = _step49.value;
          switch (c.localName) {
            case "start":
            case "left":
              output["border-left"] = values.valueOfBorder(c);
              break;
            case "end":
            case "right":
              output["border-right"] = values.valueOfBorder(c);
              break;
            case "top":
              output["border-top"] = values.valueOfBorder(c);
              break;
            case "bottom":
              output["border-bottom"] = values.valueOfBorder(c);
              break;
          }
        }
      } catch (err) {
        _iterator49.e(err);
      } finally {
        _iterator49.f();
      }
    }
  }]);
  return DocumentParser;
}();
var knownColors = ['black', 'blue', 'cyan', 'darkBlue', 'darkCyan', 'darkGray', 'darkGreen', 'darkMagenta', 'darkRed', 'darkYellow', 'green', 'lightGray', 'magenta', 'none', 'red', 'white', 'yellow'];
var xmlUtil = /*#__PURE__*/function () {
  function xmlUtil() {
    _classCallCheck(this, xmlUtil);
  }
  _createClass(xmlUtil, null, [{
    key: "colorAttr",
    value: function colorAttr(node, attrName) {
      var defValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var autoColor = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'black';
      var v = globalXmlParser.attr(node, attrName);
      if (v) {
        if (v == "auto") {
          return autoColor;
        } else if (knownColors.includes(v)) {
          return v;
        }
        return "#".concat(v);
      }
      var themeColor = globalXmlParser.attr(node, "themeColor");
      return themeColor ? "var(--docx-".concat(themeColor, "-color)") : defValue;
    }
  }]);
  return xmlUtil;
}();
var values = /*#__PURE__*/function () {
  function values() {
    _classCallCheck(this, values);
  }
  _createClass(values, null, [{
    key: "themeValue",
    value: function themeValue(c, attr) {
      var val = globalXmlParser.attr(c, attr);
      return val ? "var(--docx-".concat(val, "-font)") : null;
    }
  }, {
    key: "valueOfSize",
    value: function valueOfSize(c, attr) {
      var type = LengthUsage.Dxa;
      switch (globalXmlParser.attr(c, "type")) {
        case "dxa":
          break;
        case "pct":
          type = LengthUsage.Percent;
          break;
        case "auto":
          return "auto";
      }
      return globalXmlParser.lengthAttr(c, attr, type);
    }
  }, {
    key: "valueOfMargin",
    value: function valueOfMargin(c) {
      return globalXmlParser.lengthAttr(c, "w");
    }
  }, {
    key: "valueOfBorder",
    value: function valueOfBorder(c) {
      var type = values.parseBorderType(globalXmlParser.attr(c, "val"));
      if (type == "none") return "none";
      var color = xmlUtil.colorAttr(c, "color");
      var size = globalXmlParser.lengthAttr(c, "sz", LengthUsage.Border);
      return "".concat(size, " ").concat(type, " ").concat(color == "auto" ? autos.borderColor : color);
    }
  }, {
    key: "parseBorderType",
    value: function parseBorderType(type) {
      switch (type) {
        case "single":
          return "solid";
        case "dashDotStroked":
          return "solid";
        case "dashed":
          return "dashed";
        case "dashSmallGap":
          return "dashed";
        case "dotDash":
          return "dotted";
        case "dotDotDash":
          return "dotted";
        case "dotted":
          return "dotted";
        case "double":
          return "double";
        case "doubleWave":
          return "double";
        case "inset":
          return "inset";
        case "nil":
          return "none";
        case "none":
          return "none";
        case "outset":
          return "outset";
        case "thick":
          return "solid";
        case "thickThinLargeGap":
          return "solid";
        case "thickThinMediumGap":
          return "solid";
        case "thickThinSmallGap":
          return "solid";
        case "thinThickLargeGap":
          return "solid";
        case "thinThickMediumGap":
          return "solid";
        case "thinThickSmallGap":
          return "solid";
        case "thinThickThinLargeGap":
          return "solid";
        case "thinThickThinMediumGap":
          return "solid";
        case "thinThickThinSmallGap":
          return "solid";
        case "threeDEmboss":
          return "solid";
        case "threeDEngrave":
          return "solid";
        case "triple":
          return "double";
        case "wave":
          return "solid";
      }
      return 'solid';
    }
  }, {
    key: "valueOfTblLayout",
    value: function valueOfTblLayout(c) {
      var type = globalXmlParser.attr(c, "val");
      return type == "fixed" ? "fixed" : "auto";
    }
  }, {
    key: "classNameOfCnfStyle",
    value: function classNameOfCnfStyle(c) {
      var val = globalXmlParser.attr(c, "val");
      var classes = ['first-row', 'last-row', 'first-col', 'last-col', 'odd-col', 'even-col', 'odd-row', 'even-row', 'ne-cell', 'nw-cell', 'se-cell', 'sw-cell'];
      if (val) return classes.filter(function (_, i) {
        return val[i] == '1';
      }).join(' ');
      var attrs = ['firstRow', 'lastRow', 'firstColumn', 'lastColumn', 'oddVBand', 'evenVBand', 'oddHBand', 'evenHBand', 'firstRowLastColumn', 'firstRowFirstColumn', 'lastRowLastColumn', 'lastRowFirstColumn'];
      return classes.filter(function (_, i) {
        return globalXmlParser.boolAttr(c, attrs[i]);
      }).join(' ');
    }
  }, {
    key: "valueOfJc",
    value: function valueOfJc(c) {
      var type = globalXmlParser.attr(c, "val");
      switch (type) {
        case "start":
        case "left":
          return "left";
        case "center":
          return "center";
        case "end":
        case "right":
          return "right";
        case "both":
          return "justify";
      }
      return type;
    }
  }, {
    key: "valueOfVertAlign",
    value: function valueOfVertAlign(c) {
      var asTagName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var type = globalXmlParser.attr(c, "val");
      switch (type) {
        case "subscript":
          return "sub";
        case "superscript":
          return asTagName ? "sup" : "super";
      }
      return asTagName ? null : type;
    }
  }, {
    key: "valueOfTextAlignment",
    value: function valueOfTextAlignment(c) {
      var type = globalXmlParser.attr(c, "val");
      switch (type) {
        case "auto":
        case "baseline":
          return "baseline";
        case "top":
          return "top";
        case "center":
          return "middle";
        case "bottom":
          return "bottom";
      }
      return type;
    }
  }, {
    key: "addSize",
    value: function addSize(a, b) {
      if (a == null) return b;
      if (b == null) return a;
      return "calc(".concat(a, " + ").concat(b, ")");
    }
  }, {
    key: "classNameOftblLook",
    value: function classNameOftblLook(c) {
      var val = globalXmlParser.hexAttr(c, "val", 0);
      var className = "";
      if (globalXmlParser.boolAttr(c, "firstRow") || val & 0x0020) className += " first-row";
      if (globalXmlParser.boolAttr(c, "lastRow") || val & 0x0040) className += " last-row";
      if (globalXmlParser.boolAttr(c, "firstColumn") || val & 0x0080) className += " first-col";
      if (globalXmlParser.boolAttr(c, "lastColumn") || val & 0x0100) className += " last-col";
      if (globalXmlParser.boolAttr(c, "noHBand") || val & 0x0200) className += " no-hband";
      if (globalXmlParser.boolAttr(c, "noVBand") || val & 0x0400) className += " no-vband";
      return className.trim();
    }
  }]);
  return values;
}();
var defaultTab = {
  pos: 0,
  leader: "none",
  style: "left"
};
var maxTabs = 50;
function computePixelToPoint() {
  var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
  var temp = document.createElement("div");
  temp.style.width = '100pt';
  container.appendChild(temp);
  var result = 100 / temp.offsetWidth;
  container.removeChild(temp);
  return result;
}
function updateTabStop(elem, tabs, defaultTabSize) {
  var pixelToPoint = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 72 / 96;
  var p = elem.closest("p");
  var ebb = elem.getBoundingClientRect();
  var pbb = p.getBoundingClientRect();
  var pcs = getComputedStyle(p);
  var tabStops = (tabs === null || tabs === void 0 ? void 0 : tabs.length) > 0 ? tabs.map(function (t) {
    return {
      pos: lengthToPoint(t.position),
      leader: t.leader,
      style: t.style
    };
  }).sort(function (a, b) {
    return a.pos - b.pos;
  }) : [defaultTab];
  var lastTab = tabStops[tabStops.length - 1];
  var pWidthPt = pbb.width * pixelToPoint;
  var size = lengthToPoint(defaultTabSize);
  var pos = lastTab.pos + size;
  if (pos < pWidthPt) {
    for (; pos < pWidthPt && tabStops.length < maxTabs; pos += size) {
      tabStops.push(_objectSpread(_objectSpread({}, defaultTab), {}, {
        pos: pos
      }));
    }
  }
  var marginLeft = parseFloat(pcs.marginLeft);
  var pOffset = pbb.left + marginLeft;
  var left = (ebb.left - pOffset) * pixelToPoint;
  var tab = tabStops.find(function (t) {
    return t.style != "clear" && t.pos > left;
  });
  if (tab == null) return;
  var width = 1;
  if (tab.style == "right" || tab.style == "center") {
    var _tabStops = Array.from(p.querySelectorAll(".".concat(elem.className)));
    var nextIdx = _tabStops.indexOf(elem) + 1;
    var range = document.createRange();
    range.setStart(elem, 1);
    if (nextIdx < _tabStops.length) {
      range.setEndBefore(_tabStops[nextIdx]);
    } else {
      range.setEndAfter(p);
    }
    var mul = tab.style == "center" ? 0.5 : 1;
    var nextBB = range.getBoundingClientRect();
    var offset = nextBB.left + mul * nextBB.width - (pbb.left - marginLeft);
    width = tab.pos - offset * pixelToPoint;
  } else {
    width = tab.pos - left;
  }
  elem.innerHTML = "&nbsp;";
  elem.style.textDecoration = "inherit";
  elem.style.wordSpacing = "".concat(width.toFixed(0), "pt");
  switch (tab.leader) {
    case "dot":
    case "middleDot":
      elem.style.textDecoration = "underline";
      elem.style.textDecorationStyle = "dotted";
      break;
    case "hyphen":
    case "heavy":
    case "underscore":
      elem.style.textDecoration = "underline";
      break;
  }
}
function lengthToPoint(length) {
  return parseFloat(length);
}
var ns;
(function (ns) {
  ns["html"] = "http://www.w3.org/1999/xhtml";
  ns["svg"] = "http://www.w3.org/2000/svg";
  ns["mathML"] = "http://www.w3.org/1998/Math/MathML";
})(ns || (ns = {}));
function h(elem) {
  if (isString(elem)) return document.createTextNode(elem);
  if (elem instanceof Node) return elem;
  var ns = elem.ns,
    tagName = elem.tagName,
    className = elem.className,
    style = elem.style,
    children = elem.children,
    props = _objectWithoutProperties(elem, _excluded);
  if (tagName === "#fragment") {
    var res = document.createDocumentFragment();
    if (children) children.forEach(function (c) {
      return res.appendChild(h(c));
    });
    return res;
  }
  if (tagName === "#comment") return document.createComment(children ? children[0] : '');
  var result = ns ? document.createElementNS(ns, tagName) : document.createElement(tagName);
  if (className) result.setAttribute("class", className);
  if (style) {
    if (isString(style)) {
      result.setAttribute("style", style);
    } else {
      Object.assign(result.style, style);
    }
  }
  if (props) {
    for (var _i2 = 0, _Object$entries = Object.entries(props); _i2 < _Object$entries.length; _i2++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];
      if (value !== undefined) result[key] = value;
    }
  }
  if (children) children.forEach(function (c) {
    return result.appendChild(h(c));
  });
  return result;
}
function cx() {
  for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    classNames[_key2] = arguments[_key2];
  }
  return classNames.filter(Boolean).join(" ");
}
var HtmlRenderer = /*#__PURE__*/function () {
  function HtmlRenderer() {
    _classCallCheck(this, HtmlRenderer);
    this.className = "docx";
    this.styleMap = {};
    this.currentPart = null;
    this.tableVerticalMerges = [];
    this.currentVerticalMerge = null;
    this.tableCellPositions = [];
    this.currentCellPosition = null;
    this.footnoteMap = {};
    this.endnoteMap = {};
    this.currentEndnoteIds = [];
    this.usedHederFooterParts = [];
    this.currentTabs = [];
    this.commentMap = {};
    this.tasks = [];
    this.postRenderTasks = [];
    this.h = h;
  }
  _createClass(HtmlRenderer, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee1(document, options) {
        var _options$h;
        var result, _document$settingsPar, sectionElements;
        return regeneratorRuntime.wrap(function _callee1$(_context1) {
          while (1) {
            switch (_context1.prev = _context1.next) {
              case 0:
                this.document = document;
                this.options = options;
                this.className = options.className;
                this.rootSelector = options.inWrapper ? ".".concat(this.className, "-wrapper") : ':root';
                this.h = (_options$h = options.h) !== null && _options$h !== void 0 ? _options$h : h;
                this.styleMap = null;
                this.tasks = [];
                if (this.options.renderComments && globalThis.Highlight) {
                  this.commentHighlight = new Highlight();
                }
                result = _toConsumableArray(this.renderDefaultStyle());
                if (document.themePart) {
                  result.push.apply(result, _toConsumableArray(this.renderTheme(document.themePart)));
                }
                if (document.stylesPart != null) {
                  this.styleMap = this.processStyles(document.stylesPart.styles);
                  result.push.apply(result, _toConsumableArray(this.renderStyles(document.stylesPart.styles)));
                }
                if (!document.numberingPart) {
                  _context1.next = 21;
                  break;
                }
                this.prodessNumberings(document.numberingPart.domNumberings);
                _context1.t0 = result.push;
                _context1.t1 = result;
                _context1.t2 = _toConsumableArray;
                _context1.next = 18;
                return this.renderNumbering(document.numberingPart.domNumberings);
              case 18:
                _context1.t3 = _context1.sent;
                _context1.t4 = (0, _context1.t2)(_context1.t3);
                _context1.t0.apply.call(_context1.t0, _context1.t1, _context1.t4);
              case 21:
                if (document.footnotesPart) {
                  this.footnoteMap = keyBy(document.footnotesPart.notes, function (x) {
                    return x.id;
                  });
                }
                if (document.endnotesPart) {
                  this.endnoteMap = keyBy(document.endnotesPart.notes, function (x) {
                    return x.id;
                  });
                }
                if (document.settingsPart) {
                  this.defaultTabSize = (_document$settingsPar = document.settingsPart.settings) === null || _document$settingsPar === void 0 ? void 0 : _document$settingsPar.defaultTabStop;
                }
                if (!(!options.ignoreFonts && document.fontTablePart)) {
                  _context1.next = 33;
                  break;
                }
                _context1.t5 = result.push;
                _context1.t6 = result;
                _context1.t7 = _toConsumableArray;
                _context1.next = 30;
                return this.renderFontTable(document.fontTablePart);
              case 30:
                _context1.t8 = _context1.sent;
                _context1.t9 = (0, _context1.t7)(_context1.t8);
                _context1.t5.apply.call(_context1.t5, _context1.t6, _context1.t9);
              case 33:
                sectionElements = this.renderSections(document.documentPart.body);
                if (this.options.inWrapper) {
                  result.push(this.renderWrapper(sectionElements));
                } else {
                  result.push.apply(result, _toConsumableArray(sectionElements));
                }
                if (this.commentHighlight && options.renderComments) {
                  CSS.highlights.set("".concat(this.className, "-comments"), this.commentHighlight);
                }
                this.postRenderTasks.forEach(function (t) {
                  return t();
                });
                _context1.next = 39;
                return Promise.allSettled(this.tasks);
              case 39:
                this.refreshTabStops();
                return _context1.abrupt("return", result);
              case 41:
              case "end":
                return _context1.stop();
            }
          }
        }, _callee1, this);
      }));
      function render(_x13, _x14) {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "renderTheme",
    value: function renderTheme(themePart) {
      var _themePart$theme, _themePart$theme2;
      var variables = {};
      var fontScheme = (_themePart$theme = themePart.theme) === null || _themePart$theme === void 0 ? void 0 : _themePart$theme.fontScheme;
      if (fontScheme) {
        if (fontScheme.majorFont) {
          variables['--docx-majorHAnsi-font'] = fontScheme.majorFont.latinTypeface;
        }
        if (fontScheme.minorFont) {
          variables['--docx-minorHAnsi-font'] = fontScheme.minorFont.latinTypeface;
        }
      }
      var colorScheme = (_themePart$theme2 = themePart.theme) === null || _themePart$theme2 === void 0 ? void 0 : _themePart$theme2.colorScheme;
      if (colorScheme) {
        for (var _i3 = 0, _Object$entries2 = Object.entries(colorScheme.colors); _i3 < _Object$entries2.length; _i3++) {
          var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i3], 2),
            k = _Object$entries2$_i[0],
            v = _Object$entries2$_i[1];
          variables["--docx-".concat(k, "-color")] = "#".concat(v);
        }
      }
      var cssText = this.styleToString(".".concat(this.className), variables);
      return [this.h({
        tagName: "#comment",
        children: ["docxjs document theme values"]
      }), this.h({
        tagName: "style",
        children: [cssText]
      })];
    }
  }, {
    key: "renderFontTable",
    value: function () {
      var _renderFontTable = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee10(fontsPart) {
        var result, _iterator50, _step50, f, _iterator51, _step51, ref, fontData, cssValues;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                result = [];
                _iterator50 = _createForOfIteratorHelper(fontsPart.fonts);
                _context10.prev = 2;
                _iterator50.s();
              case 4:
                if ((_step50 = _iterator50.n()).done) {
                  _context10.next = 37;
                  break;
                }
                f = _step50.value;
                _iterator51 = _createForOfIteratorHelper(f.embedFontRefs);
                _context10.prev = 7;
                _iterator51.s();
              case 9:
                if ((_step51 = _iterator51.n()).done) {
                  _context10.next = 27;
                  break;
                }
                ref = _step51.value;
                _context10.prev = 11;
                _context10.next = 14;
                return this.document.loadFont(ref.id, ref.key);
              case 14:
                fontData = _context10.sent;
                cssValues = {
                  'font-family': encloseFontFamily(f.name),
                  'src': "url(".concat(fontData, ")")
                };
                if (ref.type == "bold" || ref.type == "boldItalic") {
                  cssValues['font-weight'] = 'bold';
                }
                if (ref.type == "italic" || ref.type == "boldItalic") {
                  cssValues['font-style'] = 'italic';
                }
                result.push(this.h({
                  tagName: "#comment",
                  children: ["docxjs ".concat(f.name, " font")]
                }));
                result.push(this.h({
                  tagName: "style",
                  children: [this.styleToString("@font-face", cssValues)]
                }));
                _context10.next = 25;
                break;
              case 22:
                _context10.prev = 22;
                _context10.t0 = _context10["catch"](11);
                if (this.options.debug) console.warn("Can't load font with id ".concat(ref.id, " and key ").concat(ref.key));
              case 25:
                _context10.next = 9;
                break;
              case 27:
                _context10.next = 32;
                break;
              case 29:
                _context10.prev = 29;
                _context10.t1 = _context10["catch"](7);
                _iterator51.e(_context10.t1);
              case 32:
                _context10.prev = 32;
                _iterator51.f();
                return _context10.finish(32);
              case 35:
                _context10.next = 4;
                break;
              case 37:
                _context10.next = 42;
                break;
              case 39:
                _context10.prev = 39;
                _context10.t2 = _context10["catch"](2);
                _iterator50.e(_context10.t2);
              case 42:
                _context10.prev = 42;
                _iterator50.f();
                return _context10.finish(42);
              case 45:
                return _context10.abrupt("return", result);
              case 46:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[2, 39, 42, 45], [7, 29, 32, 35], [11, 22]]);
      }));
      function renderFontTable(_x15) {
        return _renderFontTable.apply(this, arguments);
      }
      return renderFontTable;
    }()
  }, {
    key: "processStyleName",
    value: function processStyleName(className) {
      return className ? "".concat(this.className, "_").concat(escapeClassName(className)) : this.className;
    }
  }, {
    key: "processStyles",
    value: function processStyles(styles) {
      var _this20 = this;
      var stylesMap = keyBy(styles.filter(function (x) {
        return x.id != null;
      }), function (x) {
        return x.id;
      });
      var _iterator52 = _createForOfIteratorHelper(styles.filter(function (x) {
          return x.basedOn;
        })),
        _step52;
      try {
        for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
          var style = _step52.value;
          var baseStyle = stylesMap[style.basedOn];
          if (baseStyle) {
            style.paragraphProps = mergeDeep(style.paragraphProps, baseStyle.paragraphProps);
            style.runProps = mergeDeep(style.runProps, baseStyle.runProps);
            var _iterator54 = _createForOfIteratorHelper(baseStyle.styles),
              _step54;
            try {
              var _loop = function _loop() {
                var baseValues = _step54.value;
                var styleValues = style.styles.find(function (x) {
                  return x.target == baseValues.target;
                });
                if (styleValues) {
                  _this20.copyStyleProperties(baseValues.values, styleValues.values);
                } else {
                  style.styles.push(_objectSpread(_objectSpread({}, baseValues), {}, {
                    values: _objectSpread({}, baseValues.values)
                  }));
                }
              };
              for (_iterator54.s(); !(_step54 = _iterator54.n()).done;) {
                _loop();
              }
            } catch (err) {
              _iterator54.e(err);
            } finally {
              _iterator54.f();
            }
          } else if (this.options.debug) console.warn("Can't find base style ".concat(style.basedOn));
        }
      } catch (err) {
        _iterator52.e(err);
      } finally {
        _iterator52.f();
      }
      var _iterator53 = _createForOfIteratorHelper(styles),
        _step53;
      try {
        for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
          var _style = _step53.value;
          _style.cssName = this.processStyleName(_style.id);
        }
      } catch (err) {
        _iterator53.e(err);
      } finally {
        _iterator53.f();
      }
      return stylesMap;
    }
  }, {
    key: "prodessNumberings",
    value: function prodessNumberings(numberings) {
      var _iterator55 = _createForOfIteratorHelper(numberings.filter(function (n) {
          return n.pStyleName;
        })),
        _step55;
      try {
        for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
          var _style$paragraphProps;
          var num = _step55.value;
          var style = this.findStyle(num.pStyleName);
          if (style !== null && style !== void 0 && (_style$paragraphProps = style.paragraphProps) !== null && _style$paragraphProps !== void 0 && _style$paragraphProps.numbering) {
            style.paragraphProps.numbering.level = num.level;
          }
        }
      } catch (err) {
        _iterator55.e(err);
      } finally {
        _iterator55.f();
      }
    }
  }, {
    key: "processElement",
    value: function processElement(element) {
      if (element.children) {
        var _iterator56 = _createForOfIteratorHelper(element.children),
          _step56;
        try {
          for (_iterator56.s(); !(_step56 = _iterator56.n()).done;) {
            var e = _step56.value;
            e.parent = element;
            if (e.type == DomType.Table) {
              this.processTable(e);
            } else {
              this.processElement(e);
            }
          }
        } catch (err) {
          _iterator56.e(err);
        } finally {
          _iterator56.f();
        }
      }
    }
  }, {
    key: "processTable",
    value: function processTable(table) {
      var _iterator57 = _createForOfIteratorHelper(table.children),
        _step57;
      try {
        for (_iterator57.s(); !(_step57 = _iterator57.n()).done;) {
          var r = _step57.value;
          var _iterator58 = _createForOfIteratorHelper(r.children),
            _step58;
          try {
            for (_iterator58.s(); !(_step58 = _iterator58.n()).done;) {
              var c = _step58.value;
              c.cssStyle = this.copyStyleProperties(table.cellStyle, c.cssStyle, ["border-left", "border-right", "border-top", "border-bottom", "padding-left", "padding-right", "padding-top", "padding-bottom"]);
              this.processElement(c);
            }
          } catch (err) {
            _iterator58.e(err);
          } finally {
            _iterator58.f();
          }
        }
      } catch (err) {
        _iterator57.e(err);
      } finally {
        _iterator57.f();
      }
    }
  }, {
    key: "copyStyleProperties",
    value: function copyStyleProperties(input, output) {
      var attrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      if (!input) return output;
      if (output == null) output = {};
      if (attrs == null) attrs = Object.getOwnPropertyNames(input);
      var _iterator59 = _createForOfIteratorHelper(attrs),
        _step59;
      try {
        for (_iterator59.s(); !(_step59 = _iterator59.n()).done;) {
          var key = _step59.value;
          if (input.hasOwnProperty(key) && !output.hasOwnProperty(key)) output[key] = input[key];
        }
      } catch (err) {
        _iterator59.e(err);
      } finally {
        _iterator59.f();
      }
      return output;
    }
  }, {
    key: "createPageElement",
    value: function createPageElement(className, props, docStyle) {
      var style = _objectSpread({}, docStyle);
      if (props) {
        if (props.pageMargins) {
          style.paddingLeft = props.pageMargins.left;
          style.paddingRight = props.pageMargins.right;
          style.paddingTop = props.pageMargins.top;
          style.paddingBottom = props.pageMargins.bottom;
        }
        if (props.pageSize) {
          if (!this.options.ignoreWidth) style.width = props.pageSize.width;
          if (!this.options.ignoreHeight) style.minHeight = props.pageSize.height;
        }
      }
      return this.h({
        tagName: "section",
        className: className,
        style: style
      });
    }
  }, {
    key: "createSectionContent",
    value: function createSectionContent(props) {
      var style = {};
      if (props.columns && props.columns.numberOfColumns) {
        style.columnCount = "".concat(props.columns.numberOfColumns);
        style.columnGap = props.columns.space;
        if (props.columns.separator) {
          style.columnRule = "1px solid black";
        }
      }
      return this.h({
        tagName: "article",
        style: style
      });
    }
  }, {
    key: "renderSections",
    value: function renderSections(document) {
      var result = [];
      this.processElement(document);
      var sections = this.splitBySection(document.children, document.props);
      var pages = this.groupByPageBreaks(sections);
      var prevProps = null;
      for (var i = 0, l = pages.length; i < l; i++) {
        this.currentFootnoteIds = [];
        var section = pages[i][0];
        var props = section.sectProps;
        var pageElement = this.createPageElement(this.className, props, document.cssStyle);
        this.options.renderHeaders && this.renderHeaderFooter(props.headerRefs, props, result.length, prevProps != props, pageElement);
        var _iterator60 = _createForOfIteratorHelper(pages[i]),
          _step60;
        try {
          for (_iterator60.s(); !(_step60 = _iterator60.n()).done;) {
            var sect = _step60.value;
            var contentElement = this.createSectionContent(sect.sectProps);
            this.renderElements(sect.elements, contentElement);
            pageElement.appendChild(contentElement);
            props = sect.sectProps;
          }
        } catch (err) {
          _iterator60.e(err);
        } finally {
          _iterator60.f();
        }
        if (this.options.renderFootnotes) {
          var notes = this.renderNotes(this.currentFootnoteIds, this.footnoteMap);
          notes && pageElement.appendChild(notes);
        }
        if (this.options.renderEndnotes && i == l - 1) {
          var _notes = this.renderNotes(this.currentEndnoteIds, this.endnoteMap);
          _notes && pageElement.appendChild(_notes);
        }
        this.options.renderFooters && this.renderHeaderFooter(props.footerRefs, props, result.length, prevProps != props, pageElement);
        result.push(pageElement);
        prevProps = props;
      }
      return result;
    }
  }, {
    key: "renderHeaderFooter",
    value: function renderHeaderFooter(refs, props, page, firstOfSection, into) {
      var _this$document$settin, _this$document$settin2, _this$document$settin3, _ref, _ref2;
      if (!refs) return;
      var evenAndOddHeaders = (_this$document$settin = (_this$document$settin2 = this.document.settingsPart) === null || _this$document$settin2 === void 0 ? void 0 : (_this$document$settin3 = _this$document$settin2.settings) === null || _this$document$settin3 === void 0 ? void 0 : _this$document$settin3.evenAndOddHeaders) !== null && _this$document$settin !== void 0 ? _this$document$settin : false;
      var ref = (_ref = (_ref2 = props.titlePage && firstOfSection ? refs.find(function (x) {
        return x.type == "first";
      }) : null) !== null && _ref2 !== void 0 ? _ref2 : page % 2 == 1 && evenAndOddHeaders ? refs.find(function (x) {
        return x.type == "even";
      }) : null) !== null && _ref !== void 0 ? _ref : refs.find(function (x) {
        return x.type == "default";
      });
      var part = ref && this.document.findPartByRelId(ref.id, this.document.documentPart);
      if (part) {
        this.currentPart = part;
        if (!this.usedHederFooterParts.includes(part.path)) {
          this.processElement(part.rootElement);
          this.usedHederFooterParts.push(part.path);
        }
        var _this$renderElements = this.renderElements([part.rootElement], into),
          _this$renderElements2 = _slicedToArray(_this$renderElements, 1),
          el = _this$renderElements2[0];
        if (props !== null && props !== void 0 && props.pageMargins) {
          if (part.rootElement.type === DomType.Header) {
            el.style.marginTop = "calc(".concat(props.pageMargins.header, " - ").concat(props.pageMargins.top, ")");
            el.style.minHeight = "calc(".concat(props.pageMargins.top, " - ").concat(props.pageMargins.header, ")");
          } else if (part.rootElement.type === DomType.Footer) {
            el.style.marginBottom = "calc(".concat(props.pageMargins.footer, " - ").concat(props.pageMargins.bottom, ")");
            el.style.minHeight = "calc(".concat(props.pageMargins.bottom, " - ").concat(props.pageMargins.footer, ")");
          }
        }
        this.currentPart = null;
      }
    }
  }, {
    key: "isPageBreakElement",
    value: function isPageBreakElement(elem) {
      if (elem.type != DomType.Break) return false;
      if (elem.break == "lastRenderedPageBreak") return !this.options.ignoreLastRenderedPageBreak;
      return elem.break == "page";
    }
  }, {
    key: "isPageBreakSection",
    value: function isPageBreakSection(prev, next) {
      var _prev$pageSize, _next$pageSize, _prev$pageSize2, _next$pageSize2, _prev$pageSize3, _next$pageSize3;
      if (!prev) return false;
      if (!next) return false;
      return ((_prev$pageSize = prev.pageSize) === null || _prev$pageSize === void 0 ? void 0 : _prev$pageSize.orientation) != ((_next$pageSize = next.pageSize) === null || _next$pageSize === void 0 ? void 0 : _next$pageSize.orientation) || ((_prev$pageSize2 = prev.pageSize) === null || _prev$pageSize2 === void 0 ? void 0 : _prev$pageSize2.width) != ((_next$pageSize2 = next.pageSize) === null || _next$pageSize2 === void 0 ? void 0 : _next$pageSize2.width) || ((_prev$pageSize3 = prev.pageSize) === null || _prev$pageSize3 === void 0 ? void 0 : _prev$pageSize3.height) != ((_next$pageSize3 = next.pageSize) === null || _next$pageSize3 === void 0 ? void 0 : _next$pageSize3.height);
    }
  }, {
    key: "splitBySection",
    value: function splitBySection(elements, defaultProps) {
      var _this21 = this;
      var current = {
        sectProps: null,
        elements: [],
        pageBreak: false
      };
      var result = [current];
      var _iterator61 = _createForOfIteratorHelper(elements),
        _step61;
      try {
        for (_iterator61.s(); !(_step61 = _iterator61.n()).done;) {
          var elem = _step61.value;
          if (elem.type == DomType.Paragraph) {
            var _s$paragraphProps;
            var p = elem;
            var s = this.findStyle(p.styleName);
            if (p.pageBreakBefore || s !== null && s !== void 0 && (_s$paragraphProps = s.paragraphProps) !== null && _s$paragraphProps !== void 0 && _s$paragraphProps.pageBreakBefore) {
              current.sectProps = sectProps;
              current.pageBreak = true;
              current = {
                sectProps: null,
                elements: [],
                pageBreak: false
              };
              result.push(current);
            }
          }
          current.elements.push(elem);
          if (elem.type == DomType.Paragraph) {
            var _p = elem;
            var sectProps = _p.sectionProps;
            var pBreakIndex = -1;
            var rBreakIndex = -1;
            if (this.options.breakPages && _p.children) {
              pBreakIndex = _p.children.findIndex(function (r) {
                var _r$children$findIndex, _r$children;
                rBreakIndex = (_r$children$findIndex = (_r$children = r.children) === null || _r$children === void 0 ? void 0 : _r$children.findIndex(_this21.isPageBreakElement.bind(_this21))) !== null && _r$children$findIndex !== void 0 ? _r$children$findIndex : -1;
                return rBreakIndex != -1;
              });
            }
            if (sectProps || pBreakIndex != -1) {
              current.sectProps = sectProps;
              current.pageBreak = pBreakIndex != -1;
              current = {
                sectProps: null,
                elements: [],
                pageBreak: false
              };
              result.push(current);
            }
            if (pBreakIndex != -1) {
              var breakRun = _p.children[pBreakIndex];
              var splitRun = rBreakIndex < breakRun.children.length - 1;
              if (pBreakIndex < _p.children.length - 1 || splitRun) {
                var children = elem.children;
                var newParagraph = _objectSpread(_objectSpread({}, elem), {}, {
                  children: children.slice(pBreakIndex)
                });
                elem.children = children.slice(0, pBreakIndex);
                current.elements.push(newParagraph);
                if (splitRun) {
                  var runChildren = breakRun.children;
                  var newRun = _objectSpread(_objectSpread({}, breakRun), {}, {
                    children: runChildren.slice(0, rBreakIndex)
                  });
                  elem.children.push(newRun);
                  breakRun.children = runChildren.slice(rBreakIndex);
                }
              }
            }
          }
        }
      } catch (err) {
        _iterator61.e(err);
      } finally {
        _iterator61.f();
      }
      var currentSectProps = null;
      for (var i = result.length - 1; i >= 0; i--) {
        if (result[i].sectProps == null) {
          var _currentSectProps;
          result[i].sectProps = (_currentSectProps = currentSectProps) !== null && _currentSectProps !== void 0 ? _currentSectProps : defaultProps;
        } else {
          currentSectProps = result[i].sectProps;
        }
      }
      return result;
    }
  }, {
    key: "groupByPageBreaks",
    value: function groupByPageBreaks(sections) {
      var current = [];
      var prev;
      var result = [current];
      var _iterator62 = _createForOfIteratorHelper(sections),
        _step62;
      try {
        for (_iterator62.s(); !(_step62 = _iterator62.n()).done;) {
          var s = _step62.value;
          current.push(s);
          if (this.options.ignoreLastRenderedPageBreak || s.pageBreak || this.isPageBreakSection(prev, s.sectProps)) result.push(current = []);
          prev = s.sectProps;
        }
      } catch (err) {
        _iterator62.e(err);
      } finally {
        _iterator62.f();
      }
      return result.filter(function (x) {
        return x.length > 0;
      });
    }
  }, {
    key: "renderWrapper",
    value: function renderWrapper(children) {
      return this.h({
        tagName: "div",
        className: "".concat(this.className, "-wrapper"),
        children: children
      });
    }
  }, {
    key: "renderDefaultStyle",
    value: function renderDefaultStyle() {
      var c = this.className;
      var wrapperStyle = "\n.".concat(c, "-wrapper { background: gray; padding: 30px; padding-bottom: 0px; display: flex; flex-flow: column; align-items: center; } \n.").concat(c, "-wrapper>section.").concat(c, " { background: white; box-shadow: 0 0 10px rgba(0, 0, 0, 0.5); margin-bottom: 30px; }");
      if (this.options.hideWrapperOnPrint) {
        wrapperStyle = "@media not print { ".concat(wrapperStyle, " }");
      }
      var styleText = "".concat(wrapperStyle, "\n.").concat(c, " { color: black; hyphens: auto; text-underline-position: from-font; }\nsection.").concat(c, " { box-sizing: border-box; display: flex; flex-flow: column nowrap; position: relative; overflow: hidden; }\nsection.").concat(c, ">article { margin-bottom: auto; z-index: 1; }\nsection.").concat(c, ">footer { z-index: 1; }\n.").concat(c, " table { border-collapse: collapse; }\n.").concat(c, " table td, .").concat(c, " table th { vertical-align: top; }\n.").concat(c, " p { margin: 0pt; min-height: 1em; }\n.").concat(c, " span { white-space: pre-wrap; overflow-wrap: break-word; }\n.").concat(c, " a { color: inherit; text-decoration: inherit; }\n.").concat(c, " svg { fill: transparent; }\n");
      if (this.options.renderComments) {
        styleText += "\n.".concat(c, "-comment-ref { cursor: default; }\n.").concat(c, "-comment-popover { display: none; z-index: 1000; padding: 0.5rem; background: white; position: absolute; box-shadow: 0 0 0.25rem rgba(0, 0, 0, 0.25); width: 30ch; }\n.").concat(c, "-comment-ref:hover~.").concat(c, "-comment-popover { display: block; }\n.").concat(c, "-comment-author,.").concat(c, "-comment-date { font-size: 0.875rem; color: #888; }\n");
      }
      return [this.h({
        tagName: "#comment",
        children: ["docxjs library predefined styles"]
      }), this.h({
        tagName: "style",
        children: [styleText]
      })];
    }
  }, {
    key: "renderNumbering",
    value: function () {
      var _renderNumbering = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee11(numberings) {
        var styleText, resetCounters, _iterator63, _step63, num, selector, listStyleType, valiable, imgData, counter, counterReset;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                styleText = "";
                resetCounters = [];
                _iterator63 = _createForOfIteratorHelper(numberings);
                _context11.prev = 3;
                _iterator63.s();
              case 5:
                if ((_step63 = _iterator63.n()).done) {
                  _context11.next = 28;
                  break;
                }
                num = _step63.value;
                selector = "p.".concat(this.numberingClass(num.id, num.level));
                listStyleType = "none";
                if (!num.bullet) {
                  _context11.next = 24;
                  break;
                }
                valiable = "--".concat(this.className, "-").concat(num.bullet.src).toLowerCase();
                styleText += this.styleToString("".concat(selector, ":before"), {
                  "content": "' '",
                  "display": "inline-block",
                  "background": "var(".concat(valiable, ")")
                }, num.bullet.style);
                _context11.prev = 12;
                _context11.next = 15;
                return this.document.loadNumberingImage(num.bullet.src);
              case 15:
                imgData = _context11.sent;
                styleText += "".concat(this.rootSelector, " { ").concat(valiable, ": url(").concat(imgData, ") }");
                _context11.next = 22;
                break;
              case 19:
                _context11.prev = 19;
                _context11.t0 = _context11["catch"](12);
                if (this.options.debug) console.warn("Can't load numbering image with src ".concat(num.bullet.src));
              case 22:
                _context11.next = 25;
                break;
              case 24:
                if (num.levelText) {
                  counter = this.numberingCounter(num.id, num.level);
                  counterReset = counter + " " + (num.start - 1);
                  if (num.level > 0) {
                    styleText += this.styleToString("p.".concat(this.numberingClass(num.id, num.level - 1)), {
                      "counter-set": counterReset
                    });
                  }
                  resetCounters.push(counterReset);
                  styleText += this.styleToString("".concat(selector, ":before"), _objectSpread({
                    "content": this.levelTextToContent(num.levelText, num.suff, num.id, this.numFormatToCssValue(num.format)),
                    "counter-increment": counter
                  }, num.rStyle));
                } else {
                  listStyleType = this.numFormatToCssValue(num.format);
                }
              case 25:
                styleText += this.styleToString(selector, _objectSpread({
                  "display": "list-item",
                  "list-style-position": "inside",
                  "list-style-type": listStyleType
                }, num.pStyle));
              case 26:
                _context11.next = 5;
                break;
              case 28:
                _context11.next = 33;
                break;
              case 30:
                _context11.prev = 30;
                _context11.t1 = _context11["catch"](3);
                _iterator63.e(_context11.t1);
              case 33:
                _context11.prev = 33;
                _iterator63.f();
                return _context11.finish(33);
              case 36:
                if (resetCounters.length > 0) {
                  styleText += this.styleToString(this.rootSelector, {
                    "counter-reset": resetCounters.join(" ")
                  });
                }
                return _context11.abrupt("return", [this.h({
                  tagName: "#comment",
                  children: ["docxjs document numbering styles"]
                }), this.h({
                  tagName: "style",
                  children: [styleText]
                })]);
              case 38:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[3, 30, 33, 36], [12, 19]]);
      }));
      function renderNumbering(_x16) {
        return _renderNumbering.apply(this, arguments);
      }
      return renderNumbering;
    }()
  }, {
    key: "renderStyles",
    value: function renderStyles(styles) {
      var styleText = "";
      var stylesMap = this.styleMap;
      var defautStyles = keyBy(styles.filter(function (s) {
        return s.isDefault;
      }), function (s) {
        return s.target;
      });
      var _iterator64 = _createForOfIteratorHelper(styles),
        _step64;
      try {
        for (_iterator64.s(); !(_step64 = _iterator64.n()).done;) {
          var style = _step64.value;
          var subStyles = style.styles;
          if (style.linked) {
            var linkedStyle = style.linked && stylesMap[style.linked];
            if (linkedStyle) subStyles = subStyles.concat(linkedStyle.styles);else if (this.options.debug) console.warn("Can't find linked style ".concat(style.linked));
          }
          var _iterator65 = _createForOfIteratorHelper(subStyles),
            _step65;
          try {
            for (_iterator65.s(); !(_step65 = _iterator65.n()).done;) {
              var _style$target;
              var subStyle = _step65.value;
              var selector = "".concat((_style$target = style.target) !== null && _style$target !== void 0 ? _style$target : '', ".").concat(style.cssName);
              if (style.target != subStyle.target) selector += " ".concat(subStyle.target);
              if (defautStyles[style.target] == style) selector = ".".concat(this.className, " ").concat(style.target, ", ") + selector;
              styleText += this.styleToString(selector, subStyle.values);
            }
          } catch (err) {
            _iterator65.e(err);
          } finally {
            _iterator65.f();
          }
        }
      } catch (err) {
        _iterator64.e(err);
      } finally {
        _iterator64.f();
      }
      return [this.h({
        tagName: "#comment",
        children: ["docxjs document styles"]
      }), this.h({
        tagName: "style",
        children: [styleText]
      })];
    }
  }, {
    key: "renderNotes",
    value: function renderNotes(noteIds, notesMap) {
      var notes = noteIds.map(function (id) {
        return notesMap[id];
      }).filter(function (x) {
        return x;
      });
      if (notes.length > 0) {
        return this.h({
          tagName: "ol",
          children: this.renderElements(notes)
        });
      }
    }
  }, {
    key: "renderElement",
    value: function renderElement(elem) {
      switch (elem.type) {
        case DomType.Paragraph:
          return this.renderParagraph(elem);
        case DomType.BookmarkStart:
          return this.renderBookmarkStart(elem);
        case DomType.BookmarkEnd:
          return null;
        case DomType.Run:
          return this.renderRun(elem);
        case DomType.Table:
          return this.renderTable(elem);
        case DomType.Row:
          return this.renderTableRow(elem);
        case DomType.Cell:
          return this.renderTableCell(elem);
        case DomType.Hyperlink:
          return this.renderHyperlink(elem);
        case DomType.SmartTag:
          return this.renderSmartTag(elem);
        case DomType.Drawing:
          return this.renderDrawing(elem);
        case DomType.Image:
          return this.renderImage(elem);
        case DomType.Text:
          return this.renderText(elem);
        case DomType.Text:
          return this.renderText(elem);
        case DomType.DeletedText:
          return this.renderDeletedText(elem);
        case DomType.Tab:
          return this.renderTab(elem);
        case DomType.Symbol:
          return this.renderSymbol(elem);
        case DomType.Break:
          return this.renderBreak(elem);
        case DomType.Footer:
          return this.renderContainer(elem, "footer");
        case DomType.Header:
          return this.renderContainer(elem, "header");
        case DomType.Footnote:
        case DomType.Endnote:
          return this.renderContainer(elem, "li");
        case DomType.FootnoteReference:
          return this.renderFootnoteReference(elem);
        case DomType.EndnoteReference:
          return this.renderEndnoteReference(elem);
        case DomType.NoBreakHyphen:
          return this.h({
            tagName: "wbr"
          });
        case DomType.VmlPicture:
          return this.renderVmlPicture(elem);
        case DomType.VmlElement:
          return this.renderVmlElement(elem);
        case DomType.MmlMath:
          return this.renderContainerNS(elem, ns.mathML, "math", {
            xmlns: ns.mathML
          });
        case DomType.MmlMathParagraph:
          return this.renderContainer(elem, "span");
        case DomType.MmlFraction:
          return this.renderContainerNS(elem, ns.mathML, "mfrac");
        case DomType.MmlBase:
          return this.renderContainerNS(elem, ns.mathML, elem.parent.type == DomType.MmlMatrixRow ? "mtd" : "mrow");
        case DomType.MmlNumerator:
        case DomType.MmlDenominator:
        case DomType.MmlFunction:
        case DomType.MmlLimit:
        case DomType.MmlBox:
          return this.renderContainerNS(elem, ns.mathML, "mrow");
        case DomType.MmlGroupChar:
          return this.renderMmlGroupChar(elem);
        case DomType.MmlLimitLower:
          return this.renderContainerNS(elem, ns.mathML, "munder");
        case DomType.MmlMatrix:
          return this.renderContainerNS(elem, ns.mathML, "mtable");
        case DomType.MmlMatrixRow:
          return this.renderContainerNS(elem, ns.mathML, "mtr");
        case DomType.MmlRadical:
          return this.renderMmlRadical(elem);
        case DomType.MmlSuperscript:
          return this.renderContainerNS(elem, ns.mathML, "msup");
        case DomType.MmlSubscript:
          return this.renderContainerNS(elem, ns.mathML, "msub");
        case DomType.MmlDegree:
        case DomType.MmlSuperArgument:
        case DomType.MmlSubArgument:
          return this.renderContainerNS(elem, ns.mathML, "mn");
        case DomType.MmlFunctionName:
          return this.renderContainerNS(elem, ns.mathML, "ms");
        case DomType.MmlDelimiter:
          return this.renderMmlDelimiter(elem);
        case DomType.MmlRun:
          return this.renderMmlRun(elem);
        case DomType.MmlNary:
          return this.renderMmlNary(elem);
        case DomType.MmlPreSubSuper:
          return this.renderMmlPreSubSuper(elem);
        case DomType.MmlBar:
          return this.renderMmlBar(elem);
        case DomType.MmlEquationArray:
          return this.renderMllList(elem);
        case DomType.Inserted:
          return this.renderInserted(elem);
        case DomType.Deleted:
          return this.renderDeleted(elem);
        case DomType.CommentRangeStart:
          return this.renderCommentRangeStart(elem);
        case DomType.CommentRangeEnd:
          return this.renderCommentRangeEnd(elem);
        case DomType.CommentReference:
          return this.renderCommentReference(elem);
        case DomType.AltChunk:
          return this.renderAltChunk(elem);
      }
      return null;
    }
  }, {
    key: "renderElements",
    value: function renderElements(elems, into) {
      var _this22 = this;
      if (elems == null) return null;
      var result = elems.flatMap(function (e) {
        return _this22.renderElement(e);
      }).filter(function (e) {
        return e != null;
      });
      if (into) result.forEach(function (c) {
        return into.appendChild(isString(c) ? document.createTextNode(c) : c);
      });
      return result;
    }
  }, {
    key: "renderContainer",
    value: function renderContainer(elem, tagName, props) {
      return this.h(_objectSpread({
        tagName: tagName,
        children: this.renderElements(elem.children)
      }, props));
    }
  }, {
    key: "renderContainerNS",
    value: function renderContainerNS(elem, ns, tagName, props) {
      return this.h(_objectSpread({
        ns: ns,
        tagName: tagName,
        children: this.renderElements(elem.children)
      }, props));
    }
  }, {
    key: "renderParagraph",
    value: function renderParagraph(elem) {
      var _elem$tabs, _style$paragraphProps2, _elem$numbering, _style$paragraphProps3;
      var result = this.toHTML(elem, ns.html, "p");
      var style = this.findStyle(elem.styleName);
      (_elem$tabs = elem.tabs) !== null && _elem$tabs !== void 0 ? _elem$tabs : elem.tabs = style === null || style === void 0 ? void 0 : (_style$paragraphProps2 = style.paragraphProps) === null || _style$paragraphProps2 === void 0 ? void 0 : _style$paragraphProps2.tabs;
      var numbering = (_elem$numbering = elem.numbering) !== null && _elem$numbering !== void 0 ? _elem$numbering : style === null || style === void 0 ? void 0 : (_style$paragraphProps3 = style.paragraphProps) === null || _style$paragraphProps3 === void 0 ? void 0 : _style$paragraphProps3.numbering;
      if (numbering) {
        result.classList.add(this.numberingClass(numbering.id, numbering.level));
      }
      return result;
    }
  }, {
    key: "renderHyperlink",
    value: function renderHyperlink(elem) {
      var res = this.toH(elem, ns.html, "a");
      res.href = '';
      if (elem.id) {
        var _rel$target;
        var rel = this.document.documentPart.rels.find(function (it) {
          return it.id == elem.id && it.targetMode === "External";
        });
        res.href = (_rel$target = rel === null || rel === void 0 ? void 0 : rel.target) !== null && _rel$target !== void 0 ? _rel$target : res.href;
      }
      if (elem.anchor) {
        res.href += "#".concat(elem.anchor);
      }
      return this.h(res);
    }
  }, {
    key: "renderSmartTag",
    value: function renderSmartTag(elem) {
      return this.renderContainer(elem, "span");
    }
  }, {
    key: "renderCommentRangeStart",
    value: function renderCommentRangeStart(commentStart) {
      var _this$commentHighligh;
      if (!this.options.renderComments) return null;
      var rng = new Range();
      (_this$commentHighligh = this.commentHighlight) === null || _this$commentHighligh === void 0 ? void 0 : _this$commentHighligh.add(rng);
      var result = this.h({
        tagName: "#comment",
        children: ["start of comment #".concat(commentStart.id)]
      });
      this.later(function () {
        return rng.setStart(result, 0);
      });
      this.commentMap[commentStart.id] = rng;
      return result;
    }
  }, {
    key: "renderCommentRangeEnd",
    value: function renderCommentRangeEnd(commentEnd) {
      if (!this.options.renderComments) return null;
      var rng = this.commentMap[commentEnd.id];
      var result = this.h({
        tagName: "#comment",
        children: ["end of comment #".concat(commentEnd.id)]
      });
      this.later(function () {
        return rng === null || rng === void 0 ? void 0 : rng.setEnd(result, 0);
      });
      return result;
    }
  }, {
    key: "renderCommentReference",
    value: function renderCommentReference(commentRef) {
      var _this$document$commen;
      if (!this.options.renderComments) return null;
      var comment = (_this$document$commen = this.document.commentsPart) === null || _this$document$commen === void 0 ? void 0 : _this$document$commen.commentMap[commentRef.id];
      if (!comment) return null;
      var commentRefEl = this.h({
        tagName: "span",
        className: "".concat(this.className, "-comment-ref"),
        children: ['💬']
      });
      var commentsContainerEl = this.h({
        tagName: "div",
        className: "".concat(this.className, "-comment-popover"),
        children: [this.h({
          tagName: 'div',
          className: "".concat(this.className, "-comment-author"),
          children: [comment.author]
        }), this.h({
          tagName: 'div',
          className: "".concat(this.className, "-comment-date"),
          children: [new Date(comment.date).toLocaleString()]
        })].concat(_toConsumableArray(this.renderElements(comment.children)))
      });
      return this.h({
        tagName: "#fragment",
        children: [this.h({
          tagName: "#comment",
          children: ["comment #".concat(comment.id, " by ").concat(comment.author, " on ").concat(comment.date)]
        }), commentRefEl, commentsContainerEl]
      });
    }
  }, {
    key: "renderAltChunk",
    value: function renderAltChunk(elem) {
      if (!this.options.renderAltChunks) return null;
      var result = this.h({
        tagName: "iframe"
      });
      this.tasks.push(this.document.loadAltChunk(elem.id, this.currentPart).then(function (x) {
        result.srcdoc = x;
      }));
      return result;
    }
  }, {
    key: "renderDrawing",
    value: function renderDrawing(elem) {
      var result = this.toHTML(elem, ns.html, "div");
      result.style.display = "inline-block";
      result.style.position = "relative";
      result.style.textIndent = "0px";
      return result;
    }
  }, {
    key: "renderImage",
    value: function renderImage(elem) {
      var _elem$cssStyle, _transform, _transform2;
      var result = this.toHTML(elem, ns.html, "img", []);
      var transform = (_elem$cssStyle = elem.cssStyle) === null || _elem$cssStyle === void 0 ? void 0 : _elem$cssStyle.transform;
      if (elem.srcRect && elem.srcRect.some(function (x) {
        return x != 0;
      })) {
        var _elem$srcRect = _slicedToArray(elem.srcRect, 4),
          left = _elem$srcRect[0],
          top = _elem$srcRect[1],
          right = _elem$srcRect[2],
          bottom = _elem$srcRect[3];
        transform = "scale(".concat(1 / (1 - left - right), ", ").concat(1 / (1 - top - bottom), ")");
        result.style['clip-path'] = "rect(".concat((100 * top).toFixed(2), "% ").concat((100 * (1 - right)).toFixed(2), "% ").concat((100 * (1 - bottom)).toFixed(2), "% ").concat((100 * left).toFixed(2), "%)");
      }
      if (elem.rotation) transform = "rotate(".concat(elem.rotation, "deg) ").concat((_transform = transform) !== null && _transform !== void 0 ? _transform : '');
      result.style.transform = (_transform2 = transform) === null || _transform2 === void 0 ? void 0 : _transform2.trim();
      if (this.document) {
        this.tasks.push(this.document.loadDocumentImage(elem.src, this.currentPart).then(function (x) {
          result.src = x;
        }));
      }
      return result;
    }
  }, {
    key: "renderText",
    value: function renderText(elem) {
      return this.h(elem.text);
    }
  }, {
    key: "renderDeletedText",
    value: function renderDeletedText(elem) {
      return this.options.renderChanges ? this.renderText(elem) : null;
    }
  }, {
    key: "renderBreak",
    value: function renderBreak(elem) {
      return elem.break == "textWrapping" ? this.h({
        tagName: "br"
      }) : null;
    }
  }, {
    key: "renderInserted",
    value: function renderInserted(elem) {
      if (this.options.renderChanges) return this.renderChange(elem, "ins");
      return this.renderElements(elem.children);
    }
  }, {
    key: "renderDeleted",
    value: function renderDeleted(elem) {
      if (this.options.renderChanges) return this.renderChange(elem, "del");
      return null;
    }
  }, {
    key: "renderChange",
    value: function renderChange(elem, tag) {
      return this.renderContainer(elem, tag, {
        dateTime: elem.date
      });
    }
  }, {
    key: "renderSymbol",
    value: function renderSymbol(elem) {
      return this.h({
        tagName: "span",
        children: [String.fromCharCode(elem.char)],
        style: {
          fontFamily: elem.font
        }
      });
    }
  }, {
    key: "renderFootnoteReference",
    value: function renderFootnoteReference(elem) {
      this.currentFootnoteIds.push(elem.id);
      return this.h({
        tagName: "sup",
        children: ["".concat(this.currentFootnoteIds.length)]
      });
    }
  }, {
    key: "renderEndnoteReference",
    value: function renderEndnoteReference(elem) {
      this.currentEndnoteIds.push(elem.id);
      return this.h({
        tagName: "sup",
        children: ["".concat(this.currentEndnoteIds.length)]
      });
    }
  }, {
    key: "renderTab",
    value: function renderTab(elem) {
      var tabSpan = this.h({
        tagName: "span",
        children: ["\u2003"]
      });
      if (this.options.experimental) {
        var _findParent;
        tabSpan.className = this.tabStopClass();
        var stops = (_findParent = findParent(elem, DomType.Paragraph)) === null || _findParent === void 0 ? void 0 : _findParent.tabs;
        this.currentTabs.push({
          stops: stops,
          span: tabSpan
        });
      }
      return tabSpan;
    }
  }, {
    key: "renderBookmarkStart",
    value: function renderBookmarkStart(elem) {
      return this.h({
        tagName: "span",
        id: elem.name
      });
    }
  }, {
    key: "renderRun",
    value: function renderRun(elem) {
      if (elem.fieldRun) return null;
      var children = this.renderElements(elem.children);
      if (elem.verticalAlign) {
        children = [this.h({
          tagName: elem.verticalAlign,
          children: this.renderElements(elem.children)
        })];
      }
      var result = this.toHTML(elem, ns.html, "span", children);
      if (elem.id) result.id = elem.id;
      return result;
    }
  }, {
    key: "renderTable",
    value: function renderTable(elem) {
      this.tableCellPositions.push(this.currentCellPosition);
      this.tableVerticalMerges.push(this.currentVerticalMerge);
      this.currentVerticalMerge = {};
      this.currentCellPosition = {
        col: 0,
        row: 0
      };
      var children = [];
      if (elem.columns) children.push(this.renderTableColumns(elem.columns));
      children.push.apply(children, _toConsumableArray(this.renderElements(elem.children)));
      this.currentVerticalMerge = this.tableVerticalMerges.pop();
      this.currentCellPosition = this.tableCellPositions.pop();
      return this.toHTML(elem, ns.html, "table", children);
    }
  }, {
    key: "renderTableColumns",
    value: function renderTableColumns(columns) {
      var _this23 = this;
      var children = columns.map(function (x) {
        return _this23.h({
          tagName: "col",
          style: {
            width: x.width
          }
        });
      });
      return this.h({
        tagName: "colgroup",
        children: children
      });
    }
  }, {
    key: "renderTableRow",
    value: function renderTableRow(elem) {
      this.currentCellPosition.col = 0;
      var children = [];
      if (elem.gridBefore) children.push(this.renderTableCellPlaceholder(elem.gridBefore));
      children.push.apply(children, _toConsumableArray(this.renderElements(elem.children)));
      if (elem.gridAfter) children.push(this.renderTableCellPlaceholder(elem.gridAfter));
      this.currentCellPosition.row++;
      return this.toHTML(elem, ns.html, "tr", children);
    }
  }, {
    key: "renderTableCellPlaceholder",
    value: function renderTableCellPlaceholder(colSpan) {
      return this.h({
        tagName: "td",
        colSpan: colSpan,
        style: {
          border: "none"
        }
      });
    }
  }, {
    key: "renderTableCell",
    value: function renderTableCell(elem) {
      var result = this.toHTML(elem, ns.html, "td");
      var key = this.currentCellPosition.col;
      if (elem.verticalMerge) {
        if (elem.verticalMerge == "restart") {
          this.currentVerticalMerge[key] = result;
          result.rowSpan = 1;
        } else if (this.currentVerticalMerge[key]) {
          this.currentVerticalMerge[key].rowSpan += 1;
          result.style.display = "none";
        }
      } else {
        this.currentVerticalMerge[key] = null;
      }
      if (elem.span) result.colSpan = elem.span;
      this.currentCellPosition.col += result.colSpan;
      return result;
    }
  }, {
    key: "renderVmlPicture",
    value: function renderVmlPicture(elem) {
      return this.renderContainer(elem, "div");
    }
  }, {
    key: "renderVmlElement",
    value: function renderVmlElement(elem) {
      var _elem$imageHref;
      var container = this.h({
        ns: ns.svg,
        tagName: "svg",
        style: elem.cssStyleText
      });
      var result = this.renderVmlChildElement(elem);
      if ((_elem$imageHref = elem.imageHref) !== null && _elem$imageHref !== void 0 && _elem$imageHref.id) {
        var _this$document;
        this.tasks.push((_this$document = this.document) === null || _this$document === void 0 ? void 0 : _this$document.loadDocumentImage(elem.imageHref.id, this.currentPart).then(function (x) {
          return result.setAttribute("href", x);
        }));
      }
      container.appendChild(result);
      requestAnimationFrame(function () {
        var bb = container.firstElementChild.getBBox();
        container.setAttribute("width", "".concat(Math.ceil(bb.x + bb.width)));
        container.setAttribute("height", "".concat(Math.ceil(bb.y + bb.height)));
      });
      return container;
    }
  }, {
    key: "renderVmlChildElement",
    value: function renderVmlChildElement(elem) {
      var result = this.createSvgElement(elem.tagName);
      Object.entries(elem.attrs).forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          k = _ref4[0],
          v = _ref4[1];
        return result.setAttribute(k, v);
      });
      var _iterator66 = _createForOfIteratorHelper(elem.children),
        _step66;
      try {
        for (_iterator66.s(); !(_step66 = _iterator66.n()).done;) {
          var child = _step66.value;
          if (child.type == DomType.VmlElement) {
            result.appendChild(this.renderVmlChildElement(child));
          } else {
            result.appendChild.apply(result, _toConsumableArray(asArray(this.renderElement(child))));
          }
        }
      } catch (err) {
        _iterator66.e(err);
      } finally {
        _iterator66.f();
      }
      return result;
    }
  }, {
    key: "renderMmlRadical",
    value: function renderMmlRadical(elem) {
      var _elem$props;
      var base = elem.children.find(function (el) {
        return el.type == DomType.MmlBase;
      });
      if ((_elem$props = elem.props) !== null && _elem$props !== void 0 && _elem$props.hideDegree) {
        return this.createMathMLElement("msqrt", null, this.renderElements([base]));
      }
      var degree = elem.children.find(function (el) {
        return el.type == DomType.MmlDegree;
      });
      return this.createMathMLElement("mroot", null, this.renderElements([base, degree]));
    }
  }, {
    key: "renderMmlDelimiter",
    value: function renderMmlDelimiter(elem) {
      var _elem$props$beginChar, _elem$props$endChar;
      var children = [];
      children.push(this.createMathMLElement("mo", null, [(_elem$props$beginChar = elem.props.beginChar) !== null && _elem$props$beginChar !== void 0 ? _elem$props$beginChar : '(']));
      children.push.apply(children, _toConsumableArray(this.renderElements(elem.children)));
      children.push(this.createMathMLElement("mo", null, [(_elem$props$endChar = elem.props.endChar) !== null && _elem$props$endChar !== void 0 ? _elem$props$endChar : ')']));
      return this.createMathMLElement("mrow", null, children);
    }
  }, {
    key: "renderMmlNary",
    value: function renderMmlNary(elem) {
      var _elem$props$char, _elem$props2;
      var children = [];
      var grouped = keyBy(elem.children, function (x) {
        return x.type;
      });
      var sup = grouped[DomType.MmlSuperArgument];
      var sub = grouped[DomType.MmlSubArgument];
      var supElem = sup ? this.createMathMLElement("mo", null, asArray(this.renderElement(sup))) : null;
      var subElem = sub ? this.createMathMLElement("mo", null, asArray(this.renderElement(sub))) : null;
      var charElem = this.createMathMLElement("mo", null, [(_elem$props$char = (_elem$props2 = elem.props) === null || _elem$props2 === void 0 ? void 0 : _elem$props2.char) !== null && _elem$props$char !== void 0 ? _elem$props$char : "\u222B"]);
      if (supElem || subElem) {
        children.push(this.createMathMLElement("munderover", null, [charElem, subElem, supElem]));
      } else if (supElem) {
        children.push(this.createMathMLElement("mover", null, [charElem, supElem]));
      } else if (subElem) {
        children.push(this.createMathMLElement("munder", null, [charElem, subElem]));
      } else {
        children.push(charElem);
      }
      children.push.apply(children, _toConsumableArray(this.renderElements(grouped[DomType.MmlBase].children)));
      return this.createMathMLElement("mrow", null, children);
    }
  }, {
    key: "renderMmlPreSubSuper",
    value: function renderMmlPreSubSuper(elem) {
      var children = [];
      var grouped = keyBy(elem.children, function (x) {
        return x.type;
      });
      var sup = grouped[DomType.MmlSuperArgument];
      var sub = grouped[DomType.MmlSubArgument];
      var supElem = sup ? this.createMathMLElement("mo", null, asArray(this.renderElement(sup))) : null;
      var subElem = sub ? this.createMathMLElement("mo", null, asArray(this.renderElement(sub))) : null;
      var stubElem = this.createMathMLElement("mo", null);
      children.push(this.createMathMLElement("msubsup", null, [stubElem, subElem, supElem]));
      children.push.apply(children, _toConsumableArray(this.renderElements(grouped[DomType.MmlBase].children)));
      return this.createMathMLElement("mrow", null, children);
    }
  }, {
    key: "renderMmlGroupChar",
    value: function renderMmlGroupChar(elem) {
      var tagName = elem.props.verticalJustification === "bot" ? "mover" : "munder";
      var result = this.renderContainerNS(elem, ns.mathML, tagName);
      if (elem.props.char) {
        result.appendChild(this.createMathMLElement("mo", null, [elem.props.char]));
      }
      return result;
    }
  }, {
    key: "renderMmlBar",
    value: function renderMmlBar(elem) {
      var style = {};
      switch (elem.props.position) {
        case "top":
          style.textDecoration = "overline";
          break;
        case "bottom":
          style.textDecoration = "underline";
          break;
      }
      return this.renderContainerNS(elem, ns.mathML, "mrow", {
        style: style
      });
    }
  }, {
    key: "renderMmlRun",
    value: function renderMmlRun(elem) {
      return this.toHTML(elem, ns.mathML, "ms");
    }
  }, {
    key: "renderMllList",
    value: function renderMllList(elem) {
      var _this24 = this;
      var children = this.renderElements(elem.children).map(function (x) {
        return _this24.createMathMLElement("mtr", null, [_this24.createMathMLElement("mtd", null, [x])]);
      });
      return this.toHTML(elem, ns.mathML, "mtable", children);
    }
  }, {
    key: "toH",
    value: function toH(elem, ns, tagName) {
      var _elem$cssStyle2;
      var children = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var _ref5 = (_elem$cssStyle2 = elem.cssStyle) !== null && _elem$cssStyle2 !== void 0 ? _elem$cssStyle2 : {},
        lang = _ref5["$lang"],
        style = _objectWithoutProperties(_ref5, _excluded2);
      var className = cx(elem.className, elem.styleName && this.processStyleName(elem.styleName));
      return {
        ns: ns,
        tagName: tagName,
        className: className,
        lang: lang,
        style: style,
        children: children !== null && children !== void 0 ? children : this.renderElements(elem.children)
      };
    }
  }, {
    key: "toHTML",
    value: function toHTML(elem, ns, tagName) {
      var children = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      return this.h(this.toH(elem, ns, tagName, children));
    }
  }, {
    key: "findStyle",
    value: function findStyle(styleName) {
      var _this$styleMap;
      return styleName && ((_this$styleMap = this.styleMap) === null || _this$styleMap === void 0 ? void 0 : _this$styleMap[styleName]);
    }
  }, {
    key: "numberingClass",
    value: function numberingClass(id, lvl) {
      return "".concat(this.className, "-num-").concat(id, "-").concat(lvl);
    }
  }, {
    key: "tabStopClass",
    value: function tabStopClass() {
      return "".concat(this.className, "-tab-stop");
    }
  }, {
    key: "styleToString",
    value: function styleToString(selectors, values) {
      var cssText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var result = "".concat(selectors, " {\r\n");
      for (var key in values) {
        if (key.startsWith('$')) continue;
        result += "  ".concat(key, ": ").concat(values[key], ";\r\n");
      }
      if (cssText) result += cssText;
      return result + "}\r\n";
    }
  }, {
    key: "numberingCounter",
    value: function numberingCounter(id, lvl) {
      return "".concat(this.className, "-num-").concat(id, "-").concat(lvl);
    }
  }, {
    key: "levelTextToContent",
    value: function levelTextToContent(text, suff, id, numformat) {
      var _this25 = this,
        _suffMap$suff;
      var suffMap = {
        "tab": "\\9",
        "space": "\\a0"
      };
      var result = text.replace(/%\d*/g, function (s) {
        var lvl = parseInt(s.substring(1), 10) - 1;
        return "\"counter(".concat(_this25.numberingCounter(id, lvl), ", ").concat(numformat, ")\"");
      });
      return "\"".concat(result).concat((_suffMap$suff = suffMap[suff]) !== null && _suffMap$suff !== void 0 ? _suffMap$suff : "", "\"");
    }
  }, {
    key: "numFormatToCssValue",
    value: function numFormatToCssValue(format) {
      var _mapping$format;
      var mapping = {
        none: "none",
        bullet: "disc",
        decimal: "decimal",
        lowerLetter: "lower-alpha",
        upperLetter: "upper-alpha",
        lowerRoman: "lower-roman",
        upperRoman: "upper-roman",
        decimalZero: "decimal-leading-zero",
        aiueo: "katakana",
        aiueoFullWidth: "katakana",
        chineseCounting: "simp-chinese-informal",
        chineseCountingThousand: "simp-chinese-informal",
        chineseLegalSimplified: "simp-chinese-formal",
        chosung: "hangul-consonant",
        ideographDigital: "cjk-ideographic",
        ideographTraditional: "cjk-heavenly-stem",
        ideographLegalTraditional: "trad-chinese-formal",
        ideographZodiac: "cjk-earthly-branch",
        iroha: "katakana-iroha",
        irohaFullWidth: "katakana-iroha",
        japaneseCounting: "japanese-informal",
        japaneseDigitalTenThousand: "cjk-decimal",
        japaneseLegal: "japanese-formal",
        thaiNumbers: "thai",
        koreanCounting: "korean-hangul-formal",
        koreanDigital: "korean-hangul-formal",
        koreanDigital2: "korean-hanja-informal",
        hebrew1: "hebrew",
        hebrew2: "hebrew",
        hindiNumbers: "devanagari",
        ganada: "hangul",
        taiwaneseCounting: "cjk-ideographic",
        taiwaneseCountingThousand: "cjk-ideographic",
        taiwaneseDigital: "cjk-decimal"
      };
      return (_mapping$format = mapping[format]) !== null && _mapping$format !== void 0 ? _mapping$format : format;
    }
  }, {
    key: "refreshTabStops",
    value: function refreshTabStops() {
      var _this26 = this;
      if (!this.options.experimental) return;
      setTimeout(function () {
        var pixelToPoint = computePixelToPoint();
        var _iterator67 = _createForOfIteratorHelper(_this26.currentTabs),
          _step67;
        try {
          for (_iterator67.s(); !(_step67 = _iterator67.n()).done;) {
            var tab = _step67.value;
            updateTabStop(tab.span, tab.stops, _this26.defaultTabSize, pixelToPoint);
          }
        } catch (err) {
          _iterator67.e(err);
        } finally {
          _iterator67.f();
        }
      }, 500);
    }
  }, {
    key: "createElementNS",
    value: function createElementNS(ns, tagName, props, children) {
      return this.h(_objectSpread({
        ns: ns,
        tagName: tagName,
        children: children
      }, props));
    }
  }, {
    key: "createElement",
    value: function createElement(tagName, props, children) {
      return this.createElementNS(ns.html, tagName, props, children);
    }
  }, {
    key: "createMathMLElement",
    value: function createMathMLElement(tagName, props, children) {
      return this.createElementNS(ns.mathML, tagName, props, children);
    }
  }, {
    key: "createSvgElement",
    value: function createSvgElement(tagName, props, children) {
      return this.createElementNS(ns.svg, tagName, props, children);
    }
  }, {
    key: "later",
    value: function later(func) {
      this.postRenderTasks.push(func);
    }
  }]);
  return HtmlRenderer;
}();
function findParent(elem, type) {
  var parent = elem.parent;
  while (parent != null && parent.type != type) {
    parent = parent.parent;
  }
  return parent;
}
var defaultOptions = {
  ignoreHeight: false,
  ignoreWidth: false,
  ignoreFonts: false,
  breakPages: true,
  debug: false,
  experimental: false,
  className: "docx",
  inWrapper: true,
  hideWrapperOnPrint: false,
  trimXmlDeclaration: true,
  ignoreLastRenderedPageBreak: true,
  renderHeaders: true,
  renderFooters: true,
  renderFootnotes: true,
  renderEndnotes: true,
  useBase64URL: false,
  renderChanges: false,
  renderComments: false,
  renderAltChunks: true,
  h: h
};
function parseAsync(data, userOptions) {
  var ops = _objectSpread(_objectSpread({}, defaultOptions), userOptions);
  return WordDocument.load(data, new DocumentParser(ops), ops);
}
function renderDocument(_x17, _x18) {
  return _renderDocument.apply(this, arguments);
}
function _renderDocument() {
  _renderDocument = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee12(document, userOptions) {
    var ops, renderer;
    return regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            ops = _objectSpread(_objectSpread({}, defaultOptions), userOptions);
            renderer = new HtmlRenderer();
            _context12.next = 4;
            return renderer.render(document, ops);
          case 4:
            return _context12.abrupt("return", _context12.sent);
          case 5:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _renderDocument.apply(this, arguments);
}
function renderAsync(_x19, _x20, _x21, _x22) {
  return _renderAsync.apply(this, arguments);
}
function _renderAsync() {
  _renderAsync = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee13(data, bodyContainer, styleContainer, userOptions) {
    var _styleContainer;
    var doc, nodes, _iterator68, _step68, n, c;
    return regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.next = 2;
            return parseAsync(data, userOptions);
          case 2:
            doc = _context13.sent;
            _context13.next = 5;
            return renderDocument(doc, userOptions);
          case 5:
            nodes = _context13.sent;
            (_styleContainer = styleContainer) !== null && _styleContainer !== void 0 ? _styleContainer : styleContainer = bodyContainer;
            styleContainer.innerHTML = "";
            bodyContainer.innerHTML = "";
            _iterator68 = _createForOfIteratorHelper(nodes);
            try {
              for (_iterator68.s(); !(_step68 = _iterator68.n()).done;) {
                n = _step68.value;
                c = n.nodeName === "STYLE" ? styleContainer : bodyContainer;
                c.appendChild(n);
              }
            } catch (err) {
              _iterator68.e(err);
            } finally {
              _iterator68.f();
            }
            return _context13.abrupt("return", doc);
          case 12:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _renderAsync.apply(this, arguments);
}
export { defaultOptions, parseAsync, renderAsync, renderDocument };